import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';
import styles from './termsAndConditionsPage.module.scss';

const TermsAndConditionsPage = ({ t, title }) => {
  useEffect(() => {
    document.title = title || '';
  }, [title]);

  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      pagePath: '/terms-and-conditions',
      pageTitle: 'Terms and Conditions',
    },
  });

  const lang = t('lang');

  return (
    <div className={styles.termsAndConditionPage}>
      <div className="container">
        <div className={styles.wrapper}>
          <h4 className={styles.title}>
            {t('titles.Terms and conditions of the Xtramile Platform Client')}
          </h4>
          <h5 className={styles.subtitle}>XTRAMILE</h5>
          <h5 className={styles.subtitle}>
            {lang === 'fr'
              ? 'RCS de Metz sous le n° 808 982 037'
              : 'RCS of Metz under no. 808 982 037'}
          </h5>
          <h5 className={styles.subtitle}>26 avenue Foch, 57000 Metz (France)</h5>
          <h5 className={`${styles.subtitle} ${styles.subtitleBlock}`}><a href={"mailto:xtramile-clients@myxtramile.com"}>xtramile-clients@myxtramile.com</a></h5>

          {lang === 'fr' ? (
            <div className={styles.text}>
              <p className={styles.titleBlock}>
                <strong>1. Qui sommes-nous ?</strong>
              </p>
              <div>
                <p>
                  Nous sommes <strong>XTRAMILE</strong>, une société par actions simplifiée inscrite au RCS de Metz sous le n°808 982 037. Vous pouvez nous contacter à l’adresse e-mail qui suit : <a href={"mailto:xtramile-clients@myxtramile.com"}>xtramile-clients@myxtramile.com</a>
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>2. Que proposons-nous ?</strong>
                </p>
                <p>
                  Nous accompagnons nos clients professionnels (« <strong>Vous</strong> » ou le « <strong>Client</strong> ») à automatiser leur processus de recrutement.
                </p>
                <p>
                  A cette fin, nous mettons à leur disposition la plateforme HR Trading Desk, accessible via le site <a href={"https://www.xtramile.io"} target={"_blank"} rel="noreferrer">www.xtramile.io</a> (la « <strong>Plateforme</strong> »), un logiciel complet de diffusion des offres d’emploi multicanal (jobboards, sites carrières, métamoteurs, réseaux sociaux et canaux display) accompagné d’outils d’analyse de données (les « <strong>Outils</strong> ») pour les aider à mesurer les performances de chaque canal utilisé (ensemble les « <strong>Services</strong> »).
                </p>
                <p>
                  Les caractéristiques techniques et fonctionnelles de la Plateforme sont décrites en <a href={"#annexe1"}>Annexe 1</a>.
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>
                    3. Quels sont les documents qui régissent notre relation contractuelle ?
                  </strong>
                </p>

                <p>
                  Notre relation contractuelle est régie, par ordre hiérarchique décroissant, par les documents suivants :
                </p>

                <table width={"100%"} cellPadding={7} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={145} />
                    <col width={429} />
                  </colgroup>
                  <tbody>
                  <tr valign="top">
                    <td
                      width={145}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                          La «&nbsp;<b>Proposition Commerciale</b>»
                      </p>
                    </td>
                    <td
                      width={429}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"
                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                          Elle est établie sur la base de vos besoins et indique notamment
                          le contenu des Services souscrits, leur prix, ainsi que sa durée
                          de validité.
                      </p>
                      <ul style={{ padding: "0in 0.38in" }}>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                              Vous devez l’accepter par écrit (y compris par email) dans un
                              délai de 30 jours à compter de son émission. A défaut,
                              celle-ci est caduque. Cette acceptation vaut acceptation des
                              Conditions Générales dans leur version en vigueur à la date de
                              la Proposition Commerciale.
                          </p>
                        </li>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                              En cas de contradiction, la Proposition Commerciale prévaut
                              sur les Conditions Générales et l’Ordre d’insertion.
                          </p>
                        </li>
                        <li>
                          <p style={{ orphans: 2, widows: 2 }}>
                              En cas de contradiction, la Proposition Commerciale la plus
                              récente prévaut sur le(s) plus ancienne(s).
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={145}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                          Les «&nbsp;<b>Conditions Générales</b>&nbsp;»
                      </p>
                    </td>
                    <td
                      width={429}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"
                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Elles définissent&nbsp;:
                      </p>
                      <ul style={{ padding: "0in 0.38in" }}>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                              Les modalités d’utilisation de nos Services,
                          </p>
                        </li>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                              Nos obligations et les vôtres.
                          </p>
                        </li>
                      </ul>
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                          Vous pouvez les trouver par un lien direct en bas de page de la
                          Plateforme.
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={145}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"

                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Les bons de commande
                      </p>
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                          ou ordres d’insertion (les « <b>Ordres d’insertion</b> »)
                      </p>
                    </td>
                    <td
                      width={429}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"
                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                          Le Client pourra effectivement commander les Services en passant
                          des Ordres d’insertion par e-mail et le cas échéant par requête
                          API. Il lui sera alors demandé de renseigner un certain nombre
                          d’informations et notamment : le ou les Forfait(s) choisis ou les
                          Outils supplémentaires choisis.
                      </p>
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                          La Proposition Commerciale peut donc être suivie par l’émission
                          d’Ordre d’insertion qui doi(ven)t faire l’objet de devis qui
                          doivent être validé(s) par les parties.
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>4. Quelles autres conditions générales devez-vous accepter pour utiliser nos Services ?</strong>
                </p>
                <p>
                </p>

                <p>Tous les paiements effectués à travers notre Plateforme sont gérés par le prestataire de services de paiement indiqué sur la Plateforme (le « <strong>Prestataire de services de paiement</strong> »).</p>

                  <p>Vous contractez directement avec le Prestataire de services de paiement s’agissant de la mise en œuvre de ces paiements, en acceptant ses conditions générales, par le biais d’une case à cocher sur la Plateforme.</p>

                    <p>Si le Prestataire de services de paiement refuse ou résilie votre souscription, vous ne pouvez pas/plus utiliser nos Services.</p>

                      <p>Inversement, la fin de nos relations contractuelles entraine la résiliation de votre contrat avec le Prestataire de services de paiement.</p>

                        <p>En cas de contradiction entre les conditions générales du Prestataire de services de paiement et nos Conditions Générales, ces dernières prévalent.</p>

                          <p>Vous nous mandatez expressément pour transmettre au Prestataire de services de paiement toutes vos instructions relatives aux paiements réalisés sur la Plateforme.</p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>5. Quelles sont les conditions pour accéder à nos Services ?</strong>
                </p>

                <p>
                  <strong>(i)</strong>Vous êtes :
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Une <strong>personne physique</strong> disposant de la pleine capacité juridique,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Ou une <strong>personne morale</strong> agissant par l’intermédiaire d’une personne physique disposant du pouvoir ou de l’habilitation requise pour contracter en votre nom et pour votre compte.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>(ii)</strong><strong>Vous avez la qualité de professionnel</strong>, entendu comme toutes personnes physiques ou morales agissant à des fins entrant dans le cadre de son activité commerciale, industrielle, artisanale, libérale ou agricole, y compris lorsqu&apos;elle agit au nom ou pour le compte d&apos;un autre professionnel.
                </p>

                <p>
                  <strong>(iii)</strong>Vous êtes en mesure de garantir votre accès la Plateforme qui requiert la configuration technique minimale suivante :
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        La Plateforme est optimisée pour une résolution d&apos;écran de 1366 x 768 pixels,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Pour les navigateurs Internet : Microsoft Edge, Google Chrome, Firefox et Safari dans les versions supportées par leurs éditeurs et publiées au cours des 12 derniers mois,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Un moyen de connexion à Internet permettant l&apos;accès à la Plateforme.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>6. Comment souscrire à nos Services ?</strong>
                </p>
                <p>
                  Vous pouvez souscrire à nos Services :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Soit en remplissant le formulaire prévu à cet effet sur la Plateforme et nous fournir l’ensemble des informations marquées comme obligatoires.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Soit en nous contactant directement aux coordonnées mentionnées à l’article « Qui sommes-nous ? ». Nous vous adresserons une Proposition Commerciale, conformément à vos besoins.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Après validation de la Proposition commerciale, l’inscription entraîne automatiquement l’ouverture par nos soins d’un compte en votre nom (le « <strong>Compte</strong> ») sur la Plateforme qui vous permet d’accéder à nos Services à l’aide de votre identifiant de connexion et de votre mot de passe.
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>7. Comment vos utilisateurs peuvent-ils utiliser nos Services ?</strong>
                </p>
                  <p>Une fois votre Compte créé, nous procédons au paramétrage de la Plateforme dans les conditions prévues dans la Proposition Commerciale.</p>

                    <p>Dans l’hypothèse où vous avez souscrit à une Offre « self-managed », une fois le paramétrage réalisé par nos soins, vous pouvez librement créer des accès pour des utilisateurs (les « <strong>Utilisateurs</strong> ») dans la limite du nombre prévu dans la Proposition Commerciale.</p>

                      <p>Vous êtes seul responsable de la création des accès pour les Utilisateurs et de leur utilisation personnelle de la Plateforme.</p>

                        <p>Dans l’hypothèse où vous avez souscrit à une Offre « managed », une fois le paramétrage réalisé par nos soins, nos équipes prendront la main sur l’utilisation de la Plateforme, via le trader qui vous aura été attribué pour vous accompagner dans l’Offre « managed » souscrite (le « <strong>Trader</strong> »). Vous n’avez pas besoin de procéder à la création d’accès pour vos Utilisateurs.</p>

                <p>
                  Selon ce que prévoit la Proposition Commerciale, l’accès aux Services se fait :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        En allant directement sur la Plateforme, et/ou
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Par le biais d’une API que nous mettons à votre disposition et que vous devez intégrer sur votre système informatique. Le lien d’accès à l’API et la documentation d’intégration y afférents sont indiqués sur la Plateforme. Il est précisé que l’intégration de l’API sur votre système informatique s’opère sous votre seule responsabilité, et/ou
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Par tout moyen utile que nous jugerons appropriés.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>8. Quels sont nos services ?</strong>
                </p>
                <p>
                  <strong>8.1 Nos Services</strong>
                </p>
                <p>
                  Avant toute utilisation de nos Services, vous reconnaissez :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Avoir pris connaissance des caractéristiques et contraintes, notamment techniques, de notre Plateforme, reproduites en Annexe 1.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Que l’accès à notre Plateforme et la mise en œuvre des Services nécessitent d’être connecté à internet et que la qualité des Services dépend de cette connexion, dont nous ne sommes pas responsables.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Dans le cadre des Services auxquels vous avez souscrits, vous avez accès à tout ou partie des Outils suivants :
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        <strong>Outil AI Job Broadcast Classic</strong> : publication d’offres d’emploi sur un ou plusieurs canaux (job-boards, métamoteurs et les canaux display) gratuit(s) ou payant(s) pendant 1 à 30 jours. Cet Outil est proposé selon le seul mode « Self-managed » : vous utilisez l’Outil pour diffuser et gérer vos publications d’offres.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        <strong>Outil AI Job Broadcast Premium</strong> : L’Outil AI Job Broadcast Premium est un logiciel qui permet de piloter automatiquement la diffusion des offres d’emploi, de mener des campagnes de notoriété et de cibler des candidats sur les sites de recrutement, les réseaux sociaux et la publicité sur internet (les « <strong>Campagnes</strong> »), tout en gérant les budgets de publication et la performance de ces publications.
                      </span>
                    </p>

                    <p>
                      L’Outil <strong>AI Job Broadcast Premium</strong> est proposé selon deux modes :
                    </p>
                    <ul className={styles.listEL}>
                      <li>
                        <p>
                      <span>
                        « Self-managed » : Vous utilisez l’Outil pour diffuser et gérer vos publications d’offres, vos campagnes et vos budgets.
                      </span>
                        </p>
                      </li>
                      <li>
                        <p>
                      <span>
                        « Managed » : nous pouvons, via un de nos Traders, opérer pour votre compte les campagnes programmatiques sur la Plateforme et paramétrer les canaux à utiliser, les montants à allouer sur les canaux, les opérations techniques à effectuer et les statistiques à récolter. Ce paramétrage sera effectué dans les conditions prévues dans la Proposition Commerciale et dans la limite du budget indiqué dans cette même Proposition Commerciale.
                      </span>
                        </p>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>Outil HR Analytics & BI</strong> : consultation et exploration de vos données issues de l’usage des Services, sous forme de tableaux de bord, graphiques et fonctionnalités d’exploration des données.
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>Outil AI Predictive HR Analytics</strong> : outil permettant de consulter les statistiques de coût par candidature (CPA, « cost per application ») pour une offre d’emploi donnée, selon les principales caractéristiques de cette offre. Consultation et exploration des différentes valeurs sous forme de tableaux de bord, graphiques et fonctionnalités d’exploration des données.
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>Outil AI CV Parsing (sur option)</strong> : Transformation des CVs de candidats en format de fiches analysables ou ensemble de données récupérables pour un traitement informatique par un tiers (format JSON organisé)
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>Outil AI Scoring (sur option)</strong> : Estimation du score qualité de candidats pertinents sur la base d’offres d’emploi données et selon des critères de compréhension fine des éléments mis en avant dans les documents d’offres d’emploi et de profils de candidats.
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>Outil X-Landing Page</strong> : Mise à disposition d’une page carrière pour exposer les offres sur Internet et capter des candidatures.
                        </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Nous nous réservons la possibilité de proposer tout autre Service.
                </p>

                <p>
                  Toute demande de modification des Services souscrits devra faire l’objet d’une Proposition Commerciale complémentaire.
                </p>

                <p>
                  <strong>8.2 Licence d’accès à la Plateforme : Abonnement</strong>
                </p>
                <p>
                  Nous proposons l’accès aux Services et à la Plateforme sous forme d’un abonnement annuel (l’ « <strong>Abonnement</strong> »). La Proposition Commerciale décrit le périmètre mis à disposition, notamment le nombre d’utilisateurs et les Outils inclus dans l’Abonnement.
                </p>

                <p>
                  <strong>8.3 Consommation de Tokens</strong>
                </p>

                <p>En complément de l’Abonnement décrit ci-dessus, le Client doit passer commande de crédits (ou Tokens) pour mettre en œuvre des actions de publications d’offres et/ou de parsing de CVs.</p>

                <p>Nous proposons nos Services de multidiffusion et de parsing CVs sous la forme d’un forfait annuel (le « <strong>Forfait</strong> ») lequel donne droit à la consommation d’un nombre donné de crédits (Tokens) par le Client défini en fonction du Forfait souscrit par celui-ci (les « <strong>Tokens</strong> »).</p>

                <p>La nature du Forfait souscrit est précisée dans la Proposition Commerciale. Un Token de multi-diffusion permet de publier une offre d’emploi sur un canal pendant une durée d’un mois. Un Token de parsing CV permet d’analyser un CV, c’est-à-dire un document tel que décrit en annexe 1.a.</p>

                <p>Le nombre de Tokens correspondant au Forfait souscrit lui est crédité en totalité dès la souscription de son Forfait.</p>

                <p>Le Client est libre de consommer les Tokens à la fréquence qu’il souhaite, étant précisé que tous les Tokens non consommées au jour du renouvellement du Forfait sont définitivement perdus.</p>

                <p>Nous nous engageons à vous communiquer régulièrement des rapports vous permettant de garder une visibilité sur votre consommation de Tokens.</p>

                <p>Toute consommation de Tokens au-delà de la limite prévue dans le Forfait souscrit fera l’objet d’une facture supplémentaire qui vous sera adressée par tout moyen utile.</p>

                <p>
                  <strong>8.4 Mandat</strong>
                </p>

                <p>
                  En acceptant la Proposition commerciale et les présentes Conditions Générales, le Client nous donne expressément mandat pour mettre en œuvre tous les éléments nécessaires à la réalisation des Services tels qu’indiqués dans la Proposition commerciale.
                </p>

                <p>
                  <strong>8.5 Nos prestations complémentaires</strong>
                </p>

                <p>
                  <strong>8.5.1 On-boarding</strong>
                </p>
                <p>
                  Une fois les présentes acceptées par vos soins, nous proposons d’effectuer le paramétrage de votre environnement sur notre Plateforme. Les modalités d’exécution de cette prestation ainsi que son périmètre sont précisées dans la Proposition Commerciale.
                </p>

                <p>
                  <strong>8.5.2 Formation</strong>
                </p>
                <p>
                  Une fois les présentes acceptées par vos soins, nous nous engageons à vous fournir une formation initiale quant à l’utilisation de la Plateforme. Cette formation pourra être effectuée en visio-conférence ou en présentiel, en fonction de nos possibilités. Les modalités d’exécution de cette formation ainsi que le nombre de sessions proposées seront précisées dans la Proposition Commerciale.
                </p>
                <p>
                  Nous pourrons également vous fournir une formation complémentaire en cours d’exécution des Services, sur demande de votre part aux coordonnées indiquées à l’article « Qui sommes-nous ? ». La formation complémentaire n’étant pas comprise dans votre Abonnement, nous vous communiquerons une proposition commerciale complémentaire qui devra être acceptée par vos soins avant tout démarrage de la formation.
                </p>

                <p>
                  <strong>8.5.3 Maintenance</strong>
                </p>
                <p>
                  Vous bénéficiez pendant la durée des Services d’une maintenance corrective et évolutive.
                </p>
                <p>
                  L’accès à la Plateforme peut être limité ou suspendu pour des raisons de maintenance planifiée. Nous nous engageons à vous en informer au minimum 24 heures, par tout moyen écrit et à faire nos meilleurs efforts afin que ces opérations n’excèdent pas 8 heures et s’effectuent en dehors des heures ouvrées, soit du lundi au vendredi de 8 heures à 18 heures, heure de Paris, France.
                </p>

                <p>
                  <strong>Maintenance Evolutive</strong>
                </p>
                <p>
                  Vous bénéficiez pendant la durée des Services d’une maintenance évolutive, à savoir des :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Améliorations des fonctionnalités de la Plateforme et/ou installations techniques utilisées dans le cadre de la Plateforme visant à introduire des extensions mineures (les « Mises à Jour »). Nous pourrons les réaliser automatiquement et sans information préalable.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Ajouts de nouvelles fonctionnalités de la Plateforme et/ou des d’installations techniques utilisées dans le cadre de la Plateforme (les « Nouvelles Versions »). Nous vous informerons de toute Nouvelle Version au minimum 5 jours ouvrés avant son installation. Ne sont pas compris dans les Nouvelles Versions les mises en conformité de la Plateforme afin que celle-ci réponde aux spécificités règlementaires applicables à l’activité du Client et/ou à son secteur d’activité réglementée, qui pourra faire l’objet d’un devis spécifique.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Lorsque nous ajoutons un nouvel Outil à notre catalogue de Services, celui-ci ne fait pas partie de la Maintenance Evolutive et sera proposé à nos clients sous forme d’une option supplémentaire faisant l’objet d’une Proposition Commerciale.
                </p>


                <p>
                  <strong>Maintenance corrective</strong>
                </p>
                <p>
                  Nous faisons nos meilleurs efforts pour vous fournir une maintenance corrective afin de corriger tout dysfonctionnement ou bogue relevé sur la Plateforme.
                </p>
                <p>
                  Ces dysfonctionnements ou bogues (les « <strong>Anomalies</strong> ») se répartissent en 3 catégories :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        « Anomalie Critique » : rend impossible toute utilisation des Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        « Anomalie Majeure » : diminue l’utilisation des Services en empêchant l’utilisation de certaines fonctionnalités essentielles,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        « Anomalie Mineure » : 	vous met dans l’impossibilité d’utiliser une ou plusieurs fonctionnalités non essentielles des Services.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Vous pouvez nous signaler toute Anomalie en contactant notre support technique à l’adresse suivante : <a href={"https://xtramile.atlassian.net/servicedesk/customer/portals"}>https://xtramile.atlassian.net/servicedesk/customer/portals</a> , en vous efforçant de donner le maximum d’informations (la « <strong>Demande de Maintenance</strong> »).
                </p>

                <p>
                  Nous vous informerons de l’origine de l’Anomalie par email.
                </p>

                <p>
                  Si la Plateforme n’est pas à l’origine de l’Anomalie, et notamment si celle-ci résulte du fait d’un tiers sans manquement de notre part à nos obligations, aucune maintenance ne sera réalisée et notre responsabilité ne pourra pas être engagée à ce titre.
                </p>

                <p>
                  Si la Plateforme est à l’origine de l’Anomalie, nous nous engageons à corriger celle-ci dans les délais suivants :
                </p>

                <table width={"100%"} cellPadding={7} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={126} />
                    <col width={207} />
                    <col width={189} />
                  </colgroup>
                  <tbody>
                  <tr>
                    <td
                      width={126}
                      height={8}
                      style={{
                        background: "#d0cece",
                        border: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p className="western">
                        Qualification
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        background: "#d0cece",
                        border: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p className="western">
                        Délai de prise en charge
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        background: "#d0cece",
                        border: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p className="western">
                        Délai de correction
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={126}
                      height={28}
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p
                        className="western"

                        style={{ marginBottom: "0in" }}
                      ></p>
                      <p className="western" >
                        Anomalie Critique
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Sous deux (2) Heures Ouvrées suivant la Demande de Maintenance.
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Sous 24 Heures Ouvrées (3 Jours Ouvrés) suivant le Délai de prise en charge.
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={126}
                      height={28}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p
                        className="western"

                        style={{ marginBottom: "0in" }}
                      ></p>
                      <p className="western" >
                        Anomalie Majeure
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Sous 24 Heures Ouvrées (3 Jours Ouvrés) suivant la Demande de Maintenance.
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Sous 5 Jours Ouvrés suivant le Délai de prise en charge.
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={126}
                      height={27}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p
                        className="western"

                        style={{ marginBottom: "0in" }}
                      ></p>
                      <p className="western" >
                        Anomalie Mineure
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Sous 48 Heures Ouvrées (6 Jours Ouvrés) suivant la Demande de Maintenance.
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Sous 10 Jours Ouvrés suivant le Délai de prise en charge.
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <p>
                  La fin d’intervention sera actée par email.
                </p>

                <p>
                  Vous reconnaissez et acceptez que nous ne sommes pas tenus d’assurer une quelconque maintenance dans les cas suivants :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Refus de votre part de collaborer avec nous dans la résolution des Anomalies et notamment de répondre aux questions et demandes de renseignement ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Utilisation de la Plateforme de manière non conforme à sa destination ou à sa documentation ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Modification non autorisée de la Plateforme par vos soins, les Utilisateurs ou tout autre tiers ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Manquement à vos obligations au titre des présentes ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Implantation de tous progiciels, logiciels ou système d’exploitation non compatibles avec la Plateforme ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Défaillance des réseaux de communication électronique ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Acte volontaire de dégradation, malveillance, sabotage ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Détérioration due à un cas de force majeure telle que définie aux présentes ou à une mauvaise utilisation de la Plateforme.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>8.5.4 Hébergement</strong>
                </p>
                <p>
                  Nous assurons, dans les termes d’une obligation de moyens, l’hébergement de la Plateforme, ainsi que des données saisies sur la Plateforme, sur nos serveurs ou par l’intermédiaire d’un prestataire d’hébergement professionnel, et sur des serveurs situés dans un territoire de l’Union européenne.
                </p>

                <p>
                  <strong>8.5.5 Assistance technique</strong>
                </p>
                <p>
                  En cas de difficulté rencontrée lors de l’utilisation de nos Services, vous pouvez nous contacter aux coordonnées mentionnées à l’article « Qui sommes-nous ? ».
                </p>
                <p>
                  Nous répondrons dans les meilleurs délais en fonction de la nature de la demande, étant entendu que le support technique est ouvert aux Heures Ouvrées.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>9. Pour combien de temps souscrivez-vous à nos Services ?</strong>
                </p>
                <p>
                  Les Services sont souscrits sous la forme d’un Abonnement assorti d’un ou plusieurs Forfait(s).
                </p>
                <p>
                  L’Abonnement débute au jour de sa souscription pour une durée initiale d’un an, sauf disposition spécifique indiquée dans la Proposition Commerciale (la « <strong>Période Initiale de l’Abonnement</strong> »).
                </p>
                <p>
                  Tout Forfait souscrit en plus de l’Abonnement débute au jour de sa souscription pour une période initiale d’un an, sauf disposition spécifique indiquée dans la Proposition Commerciale (la « <strong>Période Initiale du Forfait</strong> »).
                </p>
                <p>
                  La Période Initiale de l’Abonnement et la Période Initiale du Forfait sont ci-après désignées les « <strong>Périodes Initiales</strong> »).
                </p>
                <p>
                  Les Forfaits et l’Abonnement se renouvellent ensuite tacitement pour des périodes de durée identique que leur Période Initiale respective (ci-après la/les « <strong>Période(s) Ultérieure(s)</strong> »), sauf dénonciation effectuée au plus tard :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        3 mois avant la fin de la Période Initiale  ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        3 mois avant la fin d’une Période Ultérieure.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  La Période initiale et les Périodes Ultérieures sont ci-après ensemble désignées la « <strong>Période</strong> ».
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>10. Quelles sont nos conditions financières ?</strong>
                </p>

                <p>
                  <strong>10.1 Quels sont les prix de nos Services ?</strong>
                </p>
                <p>
                  Les prix de l’Abonnement et/ou du Forfait auquel vous avez souscrit sont indiqués dans la Proposition Commerciale.
                </p>
                <p>
                  Toute Période entamée est due dans son intégralité.
                </p>
                <p>
                  Dans le cadre de l’Abonnement à l’Outil AI Job Broadcast Premium en mode « Managed », il est précisé, en tant que de besoin, que le budget alloué aux Services est indiqué dans la Proposition Commerciale. A titre d’exception, le Devis précisera les sommes consacrées à chaque Campagne et qui impactera le budget.
                </p>
                <p>
                  Dans l&apos;hypothèse où l&apos;ensemble du budget aurait été consommé avant la fin de la Période, le Client peut à tout moment recharger son Compte. Tout budget non consommé en fin de Période ne pourra faire l&apos;objet d&apos;un remboursement en cas de résiliation des présentes et fera l&apos;objet d&apos;un report sur la période suivante sous forme de réduction monétaire.
                </p>
                <p>
                  Nous sommes libres de proposer des offres promotionnelles ou des réductions de prix.
                </p>

                <p>
                  <strong>10.2 Quelles sont nos modalités de facturation et de paiement ?</strong>
                </p>
                <p>
                  Nous vous adressons une facture par Période par tout moyen utile.
                </p>
                <p>
                  Sauf mention contraire dans la Proposition Commerciale, les paiements s&apos;effectuent par virement bancaire aux coordonnées indiquées sur nos factures et dans les délais indiqués dans la Proposition Commerciale.
                </p>
                <p>
                  Vous nous garantissez disposer des autorisations nécessaires pour utiliser ce mode de paiement.
                </p>

                <p>
                  <strong>10.3 Quelles sont les conséquences d&apos;un retard ou d&apos;un défaut de paiement ?</strong>
                </p>
                <p>
                  En cas de défaut ou de retard de paiement, nous nous réservons le droit, dès le lendemain de la date d&apos;échéance figurant sur la facture, de :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Prononcer la déchéance du terme de l&apos;ensemble des sommes que vous nous devez et leur exigibilité immédiate,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Suspendre immédiatement les Services en cours jusqu&apos;au paiement de l&apos;intégralité des sommes dues,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Facturer à notre profit d&apos;un intérêt de retard égal à 3 fois le taux d&apos;intérêt légal, assis sur le montant des sommes non réglées à l&apos;échéance et d&apos;une indemnité forfaitaire de 40 euros au titre des frais de recouvrement, sans préjudice d&apos;une indemnisation complémentaire si les frais de recouvrement effectivement exposés sont supérieurs à ce montant.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>10.4 Bénéficiez-vous d&apos;un droit de rétractation ?</strong>
                </p>
                <p>
                  Vous bénéficiez d&apos;un droit de rétractation si vous êtes un professionnel qui (i) compte 5 salariés ou moins, (ii) achète un bien ou un service n&apos;entrant pas dans votre champ d&apos;activité principale (i.e. ne touche pas de près ou de loin aux Services) et que (iii) le contrat est conclu « hors établissement », à savoir :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Dans un lieu, différent de nos locaux, où nous étions présents ensemble physiquement et simultanément,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Dans vos locaux ou au moyen d&apos;une technique de communication à distance, immédiatement après que nous vous ayons sollicité personnellement et individuellement (i) dans un lieu différent de celui de nos locaux et (ii) où nous étions présents ensemble physiquement et simultanément,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Pendant une excursion que nous avons organisée afin de promouvoir nos Services.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Ce droit de rétractation est de 14 jours calendaires à compter de la signature de la Proposition Commerciale. Vous pouvez exercer ce droit gratuitement en nous envoyant avant la fin du délai aux coordonnées mentionnées à l&apos;article « Qui sommes-nous ? », une déclaration dénuée d&apos;ambiguïté, exprimant votre volonté de vous rétracter.
                </p>
                <p>
                  Si vous exercez votre droit de rétractation, nous vous rembourserons tous vos paiements reçus, en utilisant le même moyen de paiement que celui que vous avez utilisé (sauf si vous acceptez expressément un moyen différent), sans retard excessif et au plus tard 14 jours calendaires à compter du jour où nous avons été informés de votre volonté de vous rétracter.
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>11. Quels sont nos droits de propriété intellectuelle respectifs ?</strong>
                </p>

                <p>
                  <strong>11.1 Nos droits de propriété intellectuelle</strong>
                </p>
                <p>
                  La Plateforme est notre propriété, de même que les logiciels, infrastructures, bases de données et contenus de toute nature (textes, images, visuels, musiques, logos, marques, etc.) que nous exploitons, ainsi que toutes les Données d’Usage (cf. ci-dessous) qui en résultent. Ils sont protégés par tous droits de propriété intellectuelle ou droits des producteurs de bases de données en vigueur. La licence que nous vous consentons n’entraine aucun transfert de propriété.
                </p>
                <p>
                  Tous désassemblages, décompilations, décryptages, extractions, réutilisations, copies et plus généralement, tous les actes de reproduction, représentation, diffusion et utilisation de l’un quelconque de ces éléments, en tout ou partie, lorsque ces actes ne sont pas rendus nécessaires par l’exécution des Conditions Générales, ou qu’ils n’ont pas été préalablement autorisés par XTRAMILE, sont strictement interdits et pourront faire l’objet de poursuites judiciaires.
                </p>
                <p>
                  Vous, et les Utilisateurs, bénéficiez d’une licence en mode SaaS non exclusive et non transmissible d’utilisation de la Plateforme pour la durée prévue à l’article « Pour combien de temps souscrivez-vous à nos Services ? ».
                </p>
                <p>
                  Sauf mention contraire dans la Proposition Commerciale et sur accord de votre part, nous pouvons faire usage de nos noms, marques et logos respectifs et faire référence à nos plateformes respectives, à titre de références commerciales, pendant la durée de notre relation contractuelle et 5 ans au-delà.
                </p>
                <p>
                  Toutes les données générées par l’usage de notre Plateforme par les Clients (les « <strong>Données d’Usage</strong> ») sont notre propriété. A titre d’exemple ces Données d’Usage concernent notamment (et sans exhaustivité) le nombre d’offres traitées, les canaux utilisés, les métiers relatifs aux offres, les caractéristiques géographiques des publications et des offres, les dates des différents événements de publication, de campagnes, de candidatures, les nombres de candidatures. Nous garantissons que les Données d’Usage restent anonymes et à ce titre, aucune donnée personnelle au sens de la Règlementation Applicable, ni aucun nom de Client ne sont inclus dans les Données d’Usage.
                </p>

                <p>
                  <strong>11.2 Vos droits de propriété intellectuelle</strong>
                </p>
                <p>
                  Les systèmes, logiciels, structures, infrastructures, bases de données et contenus de toute nature (les « <strong>Contenus</strong> ») que vous exploitez dans le cadre de votre activité, et que vous nous communiquez en vue de la réalisation des Services, restent votre propriété et sont protégés par tous droits de propriété intellectuelle ou droits des producteurs de bases de données en vigueur.
                </p>
                <p>
                  Tous désassemblages, décompilations, décryptages, extractions, réutilisations, copies et plus généralement, tous les actes de reproduction, représentation, diffusion et utilisation de l’un quelconque de ces éléments, en tout ou partie, lorsque ces actes ne sont pas rendus nécessaires par l’exécution des Conditions Générales, ou qu’ils n’ont pas été préalablement autorisés par le Client, sont strictement interdits et pourront faire l’objet de poursuites judiciaires.
                </p>
                <p>
                  Vous ne bénéficiez au titre des présentes que d’une licence d’utilisation sur les éléments auxquels vous pouvez avoir accès ou que nous vous transmettons, pour la durée du Contrat et aux seules fins d’exécution de celui-ci.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>12. Quelles sont vos obligations et de quoi êtes-vous responsable ?</strong>
                </p>

                <p>
                  <strong>12.1 Concernant la fourniture d’informations</strong>
                </p>
                <p>
                  Vous vous engagez à nous fournir toutes les informations nécessaires pour la souscription et l’utilisation des Services.
                </p>

                <p>
                  <strong>12.2 Concernant votre Compte</strong>
                </p>
                <p>
                  Vous :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Garantissez que les informations transmises dans le formulaire sont exactes et vous engagez à les mettre à jour,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Reconnaissez que ces informations valent preuve de votre identité et vous engagent dès leur validation,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Êtes responsable du maintien de la confidentialité et de la sécurité de votre identifiant et mot de passe. Tout accès à la Plateforme à l’aide de ces derniers étant réputé effectué par vous.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Vous devez immédiatement nous contacter aux coordonnées mentionnées à l’article « Qui sommes-nous ? » si vous constatez que votre Compte a été utilisé à votre insu. Vous reconnaissez que nous aurons le droit de prendre toutes mesures appropriées en pareil cas.
                </p>
                <p>
                  Vous êtes seul responsable du paramétrage des droits d’accès des Utilisateurs.
                </p>

                <p>
                  <strong>12.3 Concernant l’utilisation des Services</strong>
                </p>
                <p>
                  Vous êtes responsable de votre utilisation des Services et de toute information que vous partagez dans ce cadre. Vous êtes également responsable de l’utilisation des Services et de toutes informations partagées par les Utilisateurs. Vous vous engagez à ce que les Services soient exclusivement utilisés par vous et/ou les Utilisateurs, qui sont soumis aux mêmes obligations que vous dans leur utilisation des Services.
                </p>
                <p>
                  Vous vous interdisez de détourner les Services à des fins autres que celles pour lesquelles ils ont été conçus, et notamment pour :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Exercer une activité illégale ou frauduleuse,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Porter atteinte à l’ordre public et aux bonnes mœurs,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Porter atteinte à des tiers ou à leurs droits, de quelque manière que ce soit,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Violer une disposition contractuelle, législative ou règlementaire,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Exercer toute activité de nature à interférer dans le système informatique d’un tiers notamment aux fins d’en violer l’intégrité ou la sécurité,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Effectuer des manœuvres visant à promouvoir vos services et/ou sites ou ceux d’un tiers,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Aider ou inciter un tiers à commettre un ou plusieurs actes ou activités listés ci-dessus.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Vous vous interdisez également de :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Copier, modifier ou détourner tout élément nous appartenant ou tout concept que nous exploitons dans le cadre des Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Adopter tout comportement de nature à interférer avec ou détourner nos systèmes informatiques ou porter atteinte à nos mesures de sécurité informatique,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Porter atteinte à nos droits et intérêts financiers, commerciaux ou moraux,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Commercialiser, transférer ou donner accès de quelque manière que ce soit aux Services, aux informations hébergées sur la Plateforme ou à tout élément nous appartenant.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Vous êtes seul responsable des Contenus de toute nature que vous diffusez dans le cadre des Services et notamment des offres d’emploi et offres de formation que vous diffusez sur la Plateforme ou que vous nous transmettez en vue de leur diffusion dans le cadre de l’Offre « Managed ».
                </p>

                <p>
                  Vous acceptez que les Contenus diffusés sur la Plateforme soient rendus publics par défaut et sont susceptibles d’être vus par d’autres utilisateurs de la Plateforme.
                </p>

                <p>
                  Vous vous interdisez de diffuser tout Contenu (cette liste n’est pas exhaustive) :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Portant atteinte à l’ordre public et aux bonnes mœurs (pornographiques, obscènes, indécents, choquants ou inadaptés à un public familial, diffamatoires, injurieux, violents, racistes, xénophobes ou révisionnistes),
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Portant atteinte aux droits de tiers (contenus contrefaisants, atteinte aux droits de la personnalité, etc.) et plus généralement violant une disposition contractuelle, législative ou règlementaire,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Préjudiciable à des tiers de quelque manière que ce soit,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Mensongers, trompeurs ou proposant ou promouvant des activités illicites, frauduleuses ou trompeuses,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Nuisibles aux systèmes informatiques de tiers.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Vous êtes responsable des relations que vous pourrez nouer avec les autres utilisateurs de la Plateforme. Vous vous engagez à agir avec discernement et respecter les règles usuelles de politesse et de courtoisie dans vos échanges avec les autres utilisateurs.
                </p>

                <p>
                  Vous nous garantissez contre toute réclamation et/ou action qui pourrait être exercée à notre encontre à la suite de la violation de l’une de vos obligations. Vous nous indemniserez du préjudice subi et nous rembourserez de toutes les sommes que nous pourrions avoir à supporter de ce fait.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>13. Quelles sont nos obligations et de quoi sommes-nous responsables ?</strong>
                </p>
                <p>
                  Nous nous engageons à fournir les Services avec diligence, étant précisé que nous sommes tenus à une obligation de moyens. Nous nous engageons également à respecter la règlementation en vigueur.
                </p>

                <p>
                  <strong>13.1 Concernant la qualité de nos Services</strong>
                </p>
                <p>
                  Nous choisissons librement les modalités pratiques et organisationnelles selon lesquelles nous réalisons les Services, sous réserve de les exécuter conformément aux règles de l’art.
                </p>
                <p>
                  Nous sommes ainsi notamment seuls juges des moyens matériels que nous décidons d’affecter à leur réalisation. Nous sommes entièrement et exclusivement responsable des moyens et, plus généralement, des modalités pratiques de leur réalisation, dont nous assurons la maîtrise complète. Pour les besoins de l’exécution des Services, nous pourrons être amenés à avoir recours à des moyens matériels spécifiques dont l’utilisation sera décidée d’un commun accord entre les Parties.
                </p>
                <p>
                  Nous faisons nos meilleurs efforts pour vous fournir des Services de qualité. A cette fin, nous procédons régulièrement à des contrôles afin de vérifier le fonctionnement et l’accessibilité de nos Services et pouvons ainsi réaliser une maintenance planifiée dans les conditions précisées à l’article « Maintenance ».
                </p>
                <p>
                  Nous ne sommes néanmoins pas responsables des difficultés ou impossibilités momentanées d’accès à nos Services qui auraient pour origine :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Des circonstances extérieures à notre réseau (et notamment la défaillance partielle ou totale de vos serveurs),
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De la défaillance d’un équipement, d’un câblage, de services ou de réseaux non inclus dans nos Services ou qui n’est pas sous notre responsabilité,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De l’interruption des Services du fait des opérateurs télécoms ou fournisseurs d’accès à internet,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De votre intervention notamment via une mauvaise configuration appliquée sur les Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        D’un cas de force majeure.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Nous sommes responsables du fonctionnement de nos serveurs, dont les limites extérieures sont constituées par les points de raccordement.
                </p>

                <p>
                  Par ailleurs, nous ne garantissons pas que les Services soumis à une recherche constante pour en améliorer notamment la performance et le progrès, seront totalement exempts d’erreurs, de vices ou défauts.
                </p>

                <p>
                  Vous reconnaissez et acceptez que les Services fournis par les Outils ne sont adaptés qu’à :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Des contenus édités par ordinateur (i.e. non manuscrits) ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Des données rédigées dans l’alphabet latin et/ou contenant une numérotation décimale ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Toute autre précision spécifiée dans la Proposition Commerciale.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Nous ne vous garantissons pas l’extraction exacte des données et informations issues des Contenus transmis sous d’autres systèmes et/ou formats que ceux évoqués ci-dessus. Par ailleurs, nous ne vous garantissons pas l’exactitude du marquage ou de la saisie des données et informations figurant dans les Contenus. Le Client reconnait et accepte que les Contenus contenant des données illisibles peuvent ne pas être traités correctement.
                </p>

                <p>
                  <strong>13.2 Concernant la garantie de niveau de service de la Plateforme</strong>
                </p>
                <p>
                  Nous faisons nos meilleurs efforts pour maintenir un accès à la Plateforme 24h/24h et 7j/7j sauf en cas de maintenance planifiée dans les conditions définies à l’article « Maintenance » ou de force majeure.
                </p>

                <p>
                  <strong>13.3 Concernant la sauvegarde des données sur la Plateforme</strong>
                </p>
                <p>
                  Nous faisons nos meilleurs efforts pour sauvegarder toutes données produites et/ou saisies par/sur la Plateforme. Sauf en cas de fautes avérées de notre part, nous ne sommes néanmoins pas responsables de toute perte de données au cours des opérations de maintenance.
                </p>

                <p>
                  <strong>13.4 Concernant le stockage et la sécurité des données</strong>
                </p>
                <p>
                  Nous vous fournissons des capacités de stockage suffisantes pour l’exploitation des Services. Nous faisons nos meilleurs efforts pour assurer la sécurité des données en mettant en œuvre des mesures de protection des infrastructures et de la Plateforme, de détection et prévention des actes malveillants et de récupération des données.
                </p>

                <p>
                  <strong>13.5 Concernant la publication de Contenus</strong>
                </p>
                <p>
                  Nous intervenons en qualité de prestataire d’hébergement pour les Contenus que vous mettez en ligne. En conséquence, nous ne sommes pas responsables de ces Contenus. Si nous recevons une notification concernant un Contenu illicite, nous agirons promptement pour le retirer ou en rendre son accès impossible, et nous pourrons prendre les mesures décrites à l’article « Quelles sont les sanctions en cas de manquement à vos obligations ? ».
                </p>

                <p>
                  <strong>13.6 Concernant la mise en relation entre utilisateurs</strong>
                </p>
                <p>
                  Nous intervenons en qualité d’intermédiaire dans vos rapports avec les autres utilisateurs. Nous ne pouvons donc pas engager notre responsabilité dans le cadre de vos relations avec les autres utilisateurs, ni être partie à quelques litiges éventuels que ce soit. A cet égard, nous ne vous garantissons pas que les candidats trouveront le poste adapté à leur demande dans la mesure où nous n’intervenons pas dans le processus de candidature.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>14. Dans quelles limites pouvez-vous engager notre responsabilité ?</strong>
                </p>
                <p>
                  Notre responsabilité est limitée aux seuls dommages directs avérés que vous subissez du fait de l’utilisation de nos Services. En tout état de cause, la responsabilité de XTRAMILE sera limitée à un montant total qui ne pourra dépasser 20% du prix annuel des Services souscrits.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>15. Quels sont les modes de preuve admis entre nous ?</strong>
                </p>
                <p>
                  La preuve peut être établie par tout moyen.
                </p>
                <p>
                  Vous êtes informé que les messages échangés par le biais de notre Plateforme ainsi que les données recueillies sur la Plateforme et nos équipements informatiques constituent le principal mode de preuve admis, notamment pour démontrer la réalité des Services réalisés et le calcul de leur prix.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>16. Comment sont traitées les données à caractère personnel dans le cadre des Services ?</strong>
                </p>

                <p>
                  <strong>16.1 Dispositions générales</strong>
                </p>
                <p>
                  Nous nous engageons mutuellement, chacun pour ce qui nous concerne, à nous conformer à la réglementation applicable aux données à caractère personnel et en particulier au Règlement Général sur la Protection des Données règlement UE 2016/679 du Parlement européen et du Conseil du 27 avril 2016) et à la loi relative à l’Informatique et aux Libertés du 6 janvier 1978 dans sa dernière version en vigueur (ci-après dénommés ensemble la « <strong>Réglementation applicable</strong> »).
                </p>

                <p>
                  <strong>16.2 Lorsque nous collectons vos données à caractère personnel aux fins de gestion commerciale en notre qualité de responsable de traitement</strong>
                </p>
                <p>
                  Nous agissons en tant que responsable de traitement au sens de la Réglementation applicable dans le cadre des traitements relatifs à la gestion commerciale. Dans ce cadre, vos données à caractère personnel sont conservées pendant la durée strictement nécessaire à la gestion de nos relations contractuelles avec vous. Notre personnel, nos services chargés du contrôle (commissaire aux comptes notamment) et nos sous-traitants pourront avoir accès aux données à caractère personnel collectées.
                </p>
                <p>
                  Ces traitements sont nécessaires à la bonne exécution du présent Contrat. Il pourra donner lieu à l’exercice par les personnes concernées de leur droit (i) d’obtenir la communication et, le cas échéant, la rectification ou la suppression des données le concernant, (ii) de demander l’effacement ou la limitation du traitement, (iii) de s’opposer au traitement pour des motifs légitimes, (iv) de demander la portabilité des données le concernant, afin de les récupérer et de les conserver, et (v) d’introduire une réclamation auprès d’une autorité de contrôle compétente.
                </p>

                <p>
                  <strong>16.3 Lorsque nous collectons les données à caractère personnel des Utilisateurs en votre nom en notre qualité de sous-traitant</strong>
                </p>
                <p>L’objet de cette clause est de définir les conditions selon lesquelles nous entreprenons, en votre nom, le traitement de données personnelles décrit ci-dessous.</p>

                <p>
                  <strong>16.3.1 Description du traitement sous-traité</strong>
                </p>
                <p>Dans le cadre des Services, nous sommes amenés à traiter des données à caractère personnel en qualité de sous-traitant au sens de la Réglementation applicable en votre nom et pour votre compte. Vous, vous agissez en qualité de responsable de traitement au sens de la Réglementation applicable. Les caractéristiques des traitements sont décrites en Annexe 2 des Conditions Générales.</p>

                <p>
                  <strong>16.3.2 Nos obligations vis-à-vis de vous</strong>
                </p>
                <p>
                  <strong>Traitement des données :</strong>
                </p>
                <p>Nous nous engageons à ne traiter les données à caractère personnel qu’aux fins des finalités listées à l’Annexe 2 et conformément à vos instructions documentées, y compris en ce qui concerne le transfert des données en dehors de l’Union Européenne. Nous nous engageons à vous informer si, selon nous, une instruction constitue une violation de la Réglementation applicable. En outre, si nous sommes tenus de procéder à un transfert de données vers un pays tiers ou à une organisation internationale, en vertu du droit applicable aux présentes Conditions Générales, nous vous informerons de cette obligation juridique avant le traitement, sauf si le droit concerné interdit une telle information pour des motifs importants d’intérêt public.</p>

                <p>
                  <strong>Sécurité et confidentialité des données :</strong>
                </p>
                <p>Nous nous engageons à mettre en œuvre les mesures techniques et organisationnelles appropriées pour assurer la sécurité et l’intégrité des données à caractère personnel, leur sauvegarde ainsi que le rétablissement de leur disponibilité en cas d’incident physique ou technique. Nous veillons également à ce que les personnes autorisées à traiter les données à caractère personnel soient soumises à l’obligation d’en préserver la confidentialité. </p>

                <p>
                  <strong>Autres sous-traitants :</strong>
                </p>
                <p>Nous sommes autorisés à faire appel aux sous-traitants (le « <strong>Sous-traitant ultérieur</strong> ») listés en Annexe 1 des Conditions Générales pour mener des activités de traitement spécifiques. En cas de changement dans la liste des Sous-traitants ultérieurs autorisés, nous vous informerons préalablement et par écrit. Cette information devra indiquer clairement les activités de traitement sous-traitées, l’identité et les coordonnées du Sous-traitant ultérieur. Vous disposez d’un délai de 15 (quinze) jours à compter de la date de réception de cette information pour présenter vos objections légitimes et motivées. A défaut de notifications d’objections passé ce délai, vous serez réputé avoir accepté le recours au Sous-traitant ultérieur.</p>
                <p>Le Sous-traitant ultérieur est tenu de respecter les obligations des présentes Conditions Générales pour votre compte et selon vos instructions. Il nous appartient de nous assurer que le Sous-traitant ultérieur présente les mêmes garanties suffisantes quant à la mise en œuvre de mesures techniques et organisationnelles appropriées de manière à ce que le traitement réponde aux exigences de la Réglementation applicable. Si le Sous-traitant ultérieur ne remplit pas ses obligations en matière de protection des données, nous demeurons responsables devant vous de l’exécution par le Sous-traitant ultérieur de ses obligations.</p>

                <p>
                  <strong>Transfert de données à caractère personnel hors de l’Union européenne :</strong>
                </p>
                <p>Nous sommes autorisés à transférer les données à caractère personnel traitées dans le cadre des présentes Conditions Générales vers des pays situés hors de l’Union européenne, sous réserve de la mise en place de garanties appropriées telles que définies au Chapitre V du règlement précité.</p>

                <p>
                  <strong>Assistance et Fourniture d’informations :</strong>
                </p>
                <p>Nous nous engageons à vous assister et répondre dans les meilleurs délais à toute demande d’information nous étant adressée par vous, que ce soit dans le cadre d’une demande d’exercice de leurs droits par les personnes concernées, d’une analyse d’impact ou d’une demande présentée par les autorités de protection des données ou votre délégué à la protection des données.</p>

                <p>
                  <strong>Notification des violations de données à caractère personnel :</strong>
                </p>
                <p>Nous nous engageons à vous notifier toute violation des données à caractère personnel et à vous communiquer toute information et documentation utile pour vous permettre le cas échéant de notifier cette violation à l’autorité de contrôle compétente, dans les meilleurs délais après en avoir pris connaissance.</p>

                <p>
                  <strong>Sort des données :</strong>
                </p>
                <p>Nous nous engageons à notre choix, à supprimer les données à caractère personnel à la fin de votre utilisation des Services ou à vous les renvoyer et à ne pas en conserver de copie, sauf si la Réglementation applicable l’exige.</p>

                <p>
                  <strong>Documentation :</strong>
                </p>
                <p>Nous mettons à votre disposition, à votre demande, toutes les informations et tous les documents nécessaires pour démontrer le respect de nos obligations et pour permettre la réalisation d’audits. Vous avez ainsi la possibilité de procéder à des audits une fois par an et à vos frais afin de vérifier notre conformité aux obligations prévues dans le présent article relatif aux données personnelles. Vous nous informerez de la tenue de l’audit moyennant un préavis minimum de deux (2) semaines. Nous nous réservons le droit de refuser l’identité de l’auditeur retenu s’il appartient à une société concurrente. L’audit devra être réalisé pendant nos Heures Ouvrées et de manière à perturber le moins possible notre activité. L’audit ne pourra ainsi porter atteinte de quelque façon que ce soit (i) à nos mesures techniques et organisationnelles de sécurité déployées, (ii) à la sécurité et la confidentialité des données de nos autres clients, (iii) ni au bon fonctionnement et à l’organisation de notre production. Dans la mesure du possible, nous conviendrons à l’avance du périmètre de l’audit. Le rapport d’audit devra nous être adressé afin de nous permettre de formuler nos observations ou remarques éventuelles par écrit, lesquelles seront annexées à la version finale du rapport d’audit. Chaque rapport d’audit sera considéré comme une information confidentielle. Si le rapport d’audit révèle une non-conformité de notre société à la Règlementation applicable, nous nous engageons à vous rembourser les frais d’audit dans la limite de 1% des montants qui vous auront été facturés au titre des Services et, en tout état de cause, ce montant ne pouvant pas dépasser 3000 euros hors taxes.  </p>

                <p>
                  <strong>16.3.3 Vos obligations à notre égard</strong>
                </p>
                <p>Vous vous engagez à :</p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Nous fournir les données personnelles visées dans l’Annexe 1, à l’exclusion de toute donnée personnelle non pertinente, disproportionnée ou non nécessaire, et à l’exclusion de toute donnée « particulière » au sens de la Réglementation applicable, sauf si les traitements le justifient, à charge pour vous d’établir ces justifications et de prendre toutes mesures, notamment d’information préalable, de recueil de consentement et de sécurité, appropriées pour de telles données particulières ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Collecter sous votre responsabilité, de manière licite, loyale et transparente, les données personnelles que vous nous fournissez, pour l’exécution des Services, et en particulier, vous assurer de la base légale de cette collecte et de l’information due aux personnes concernées ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Tenir un registre des traitements et plus généralement, respecter les principes issus de la Réglementation Applicable ;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Veiller au préalable et pendant toute la durée du traitement, au respect des obligations prévues par la Réglementation Applicable.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>17. Quelles sont nos obligations respectives en matière de confidentialité ?</strong>
                </p>
                <p>
                  Sauf accord écrit de l’autre partie, nous nous engageons respectivement à garder confidentiels, pendant la durée de notre relation contractuelle et 3 ans au-delà, toutes les informations relatives ou détenus par l’autre partie, dont nous aurions eu connaissance à l’occasion de la conclusion et de l’exécution de notre relation contractuelle.
                </p>
                <p>
                  Cette obligation ne s’étend pas aux informations :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Dont la partie qui les reçoit avait déjà connaissance,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Déjà publics lors de leur communication ou qui le deviendraient sans violation de cette clause,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Qui auraient été reçues d’un tiers de manière licite,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Dont la communication serait exigée par les autorités judiciaires, en application des lois et règlements ou en vue d’établir les droits d’une partie dans la cadre de notre relation contractuelle.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Les informations confidentielles peuvent être transmises à nos employés, collaborateurs, stagiaires, mandataires et cocontractants respectifs, à condition qu’ils soient soumis à la même obligation de confidentialité.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>18. Force majeure</strong>
                </p>
                <p>
                  Nous ne pouvons être responsable des manquements ou retards dans l’exécution de nos obligations contractuelles respectives dus à un cas de force majeure survenu pendant la durée de nos relations. La force majeure recouvre :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Tout cas répondant aux conditions de l’article 1218 du Code civil et reconnus par la jurisprudence,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Les grèves, activités terroristes, émeutes, insurrections, guerres, actions gouvernementales, épidémies, catastrophes naturelles ou défaut imputable à un prestataire tiers de télécommunication.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Si l’un d’entre nous est empêché d’exécuter ses obligations pour un cas de force majeure, il doit informer l’autre partie par lettre recommandée avec demande d’avis de réception. Les obligations sont suspendues dès réception de la lettre, et devront être reprises dans un délai raisonnable dès la cessation du cas de force majeure.
                </p>
                <p>
                  Nous restons néanmoins tenus de l’exécution de nos obligations respectives qui ne sont pas affectées par un cas de force majeure et de toute obligation de paiement.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>19. Comment mettre fin aux Services ?</strong>
                </p>
                <p>
                  Les Services peuvent être résiliés au plus tard 3 (trois) mois avant la fin de la Période en cours, par :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Vous, en nous adressant une demande aux coordonnées mentionnées à l’article « Qui sommes-nous ? »,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Nous, en vous adressant un email.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Vous n’avez plus accès à votre compte à compter de la fin des Services. Tout Token non consommé au jour de la fin des Services sera définitivement perdu et ne pourra faire l’objet d’un remboursement.
                </p>

                <p>
                  La fin des présentes, qu’elle qu’en soit la cause hormis lorsqu’elle est due à un cas de force majeure dans les conditions définies à l’article « Force majeure », est sans incidence sur les Ordres d’insertion validés par Devis qui sont en cours, qui doivent être exécutés selon les modalités prévues aux présentes.
                </p>

                <p>
                  La fin des Conditions Générales est également sans incidence sur les dispositions des présentes ayant vocation à perdurer au-delà, et notamment les articles « Propriété intellectuelle », « Confidentialité » et le présent article.
                </p>

                <p>
                  Toute Période entamée est due dans son intégralité.
                </p>

                <p>
                  La résiliation entraîne la suppression de votre Compte. Vous reconnaissez et acceptez qu’en cas de résiliation des Services, l’ensemble des paramétrages que vous aurez effectués sur la Plateforme seront perdus.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>20. Quelles sont les sanctions en cas de manquement à vos obligations ?</strong>
                </p>

                <p>
                  Le paiement du prix des Services ainsi que les obligations prévues à l’article « Quelles sont vos obligations et de quoi êtes-vous responsable ? » constituent des obligations essentielles.
                </p>

                <p>
                  En cas de manquement à ces obligations, nous pouvons :
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Suspendre ou supprimer votre accès aux Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Supprimer tout Contenu en lien avec le manquement,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Publier sur la Plateforme tout message d’information que nous jugeons utile,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Vous envoyer une lettre recommandée avec accusé de réception pour :
                      </span>
                    </p>

                    <ul className={styles.listEL}>
                      <li>
                        <p>
                          <span>
                            Mettre fin à nos relations contractuelles, la résiliation prenant effet au jour de réception ou de première présentation de cette lettre,
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                        Ou pour vous demander de remédier au manquement dans un délai maximum de 15 jours calendaires. La résiliation prendra effet à l’issue de ce délai à défaut de régularisation du manquement.
                      </span>
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>
                      <span>
                        Avertir toute autorité compétente, coopérer avec elle et lui fournir toutes les informations utiles à la recherche et à la répression d’activités illégales ou illicites,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Engager toute action judiciaire.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Ces sanctions sont sans préjudice de tous dommages et intérêts que nous pourrions vous réclamer.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>21. Comment pouvons-nous modifier nos Conditions Générales ?</strong>
                </p>

                <p>
                  Nous pouvons modifier nos Conditions Générales à tout moment et vous en informerons par tout moyen écrit (et notamment par email) 3 mois au moins avant leur entrée en vigueur.
                </p>

                <p>
                  Les Conditions Générales modifiées sont applicables lors du renouvellement de votre Forfait.
                </p>

                <p>
                  Si vous n’acceptez pas ces modifications, vous devez résilier vos Services selon les modalités prévues à l’article « Comment mettre fin aux Services ? ».
                </p>

                <p>
                  Si vous utilisez nos Services après l’entrée en vigueur de nos Conditions Générales modifiées, nous considérons que vous les avez acceptées.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>22. Signature électronique</strong>
                </p>

                <p>
                  Il est entendu que la Proposition Commerciale, et subséquemment les présentes Conditions Générales, pourront être signées par tout moyen électronique, nous reconnaissons mutuellement la fiabilité du procédé lui conférant ainsi la même valeur juridique qu&apos;une signature manuscrite au sens de la loi.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>23. Loi applicable et juridictions compétentes</strong>
                </p>

                <p>
                  Nos Conditions Générales sont régies par la loi française. En cas de litige nous opposant, et à défaut d’accord amiable dans les 2 mois suivant la première notification, celui-ci sera soumis à la compétence exclusive des tribunaux de Metz (France), sauf dispositions impératives contraires.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock} id={"annexe1"}>
                  <strong>24. Annexe 1 - Caractéristiques fonctionnelles et technique de la Plateforme</strong>
                </p>

                <p>
                  <strong>24.1 AI Job Broadcast Classic</strong>
                </p>
                <p>
                  L’Outil AI Job Broadcast Classic permet de publier automatiquement des d’offres d’emploi sur un ou plusieurs canaux (jobboards, métamoteurs et les canaux display) gratuit(s) ou payant(s). Cet Outil est proposé selon le seul mode « Self-managed » : vous utilisez l’Outil pour diffuser et gérer vos publications d’offres.
                </p>
                <p>
                  L’Outil permet notamment de :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        D’importer, modifier, supprimer, et diffuser automatiquement des offres
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De mettre les offres en conformité grâce à nos modèles d’IA qui corrigent le contenu des offres pour en augmenter la qualité, retirer tout propos discriminatoire et préparer la mise en qualité du contenu qui assurera un taux de succès optimale de publication sur vos canaux préférés.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        D’éditer une politique de publication au travers de règles régissant les conditions qui déclencheront automatiquement les publications (« autoposting »), ainsi que les canaux cibles à utiliser. Les règles s’appuient sur n’importe quels attributs de l’offre
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De dépublier automatiquement des offres d’emploi selon les mêmes règles de publication / dépublication choisies (date donnée, par exemple)
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Gagner en temps, en fiabilité et en productivité grâce à des fonctionnalités avancées comme par exemple la duplication d’offres selon leur géographie
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De consulter les différents indicateurs de consommation de Tokens et d’état des traitements sur les offres : imports, mise en conformité, publication, dépublication, mise en pause etc.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        De consulter la liste des jobboards disponibles se trouve dans le Catalogue Public des canaux
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Pour les organisations partenaires qui gèrent plusieurs de leurs clients grâce à la Plateforme Xtramile, il est possible de créer un espace séparé par client (séparation des données par client), grâce aux concepts de compte Client et de compte Bureau.
                </p>

                <p>
                  Les fonctionnalités de l’Outil sont disponibles depuis une interface utilisateur ou à partir d’une API.
                </p>

                <p>
                  <strong>24.2 AI Job Broadcast Premium</strong>
                </p>

                <p>
                  L’Outil AI Job Broadcast Premium inclut toutes les fonctionnalités du l’Outil AI Job Broadcast Classic auxquelles s’ajoutent les fonctionnalités suivantes :
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Gestion de campagnes de diffusion
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Gestion des budgets liés aux campagnes.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Synchronisation automatique des budgets et campagnes avec les plateformes partenaires (nous consulter pour connaitre la liste des plateformes de gestion supportées).
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Accès à des canaux de publication avancés tels que
                      </span>
                    </p>
                    <ul className={styles.listEL}>
                      <li>
                        <p>
                          <span>
                            Boost
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Search Ads
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Socials Ads
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Targeted Ads
                          </span>
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>
                      <span>
                        Gestion des comptes utilisateurs.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  De plus l’Outil <strong>AI Job Broadcast Premium</strong> est proposé selon deux modes :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        « Self-managed » : Vous utilisez l’Outil pour diffuser et gérer vos publications d’offres, vos campagnes et vos budgets.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        « Managed » : nous pouvons, via un de nos Traders, opérer pour votre compte les campagnes programmatiques sur la Plateforme et paramétrer les canaux à utiliser, les montants à allouer sur les canaux, les opérations techniques à effectuer et les statistiques à récolter.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>24.3 Outil HR Analytics & BI</strong>
                </p>
                <p>
                  Consultation et exploration de vos données issues de l’usage des Services, sous forme de tableaux de bord, graphiques et fonctionnalités d’exploration des données. L’Outil est structuré autour de deux tableaux de bord principaux :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Analyse des offres et des publications, selon plusieurs dimensions telles que : intervalle de temps, répartition par canal de diffusion, par métier, par secteur d’activité, par région, variation au cours du temps
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Acquisition et analyse des coûts, également analysables selon plusieurs dimensions telles que : intervalle de temps, répartition par canal de diffusion, par campagne, par métier, par région, variation au cours du temps.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>24.4 Outil AI Predictive HR Analytics</strong>
                </p>
                <p>
                  Outil permettant de consulter et d’anticiper les coût par candidature (CPA, « cost per application ») pour une offre d’emploi donné, selon les principales caractéristiques de cette offre. Consultation et exploration des différentes valeurs sous forme de tableaux de bord, graphiques et fonctionnalités d’exploration des données.
                </p>
                <p>
                  Les données sont analysables selon les dimensions suivantes : le métier, le type de canal de diffusion, la région géographique.
                </p>

                <p>
                  <strong>24.5 Outil AI CV Parsing (sur option)</strong>
                </p>
                <p>
                  Le système de Parsing Xtramile est capable d’analyser sémantiquement du texte libre ou des CV scannés, voire également des dossiers de candidature complets. Les documents à analyser sont mis à disposition (téléchargés) au format DOC, DOCX (MS Word), PDF (Portable Document Format), ODT (OpenOffice), TXT (Texte brut), RTF (RichText), PNG ou JPEG (Joint Photographic Experts Group) ou TIFF (Tagged Image File), HTML.
                </p>
                <p>
                  Le résultat de l&apos;extraction est fourni sous la forme d&apos;un ensemble de données JSON.
                </p>
                <p>
                  Les fonctions clés du Parsing sont :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Extraction d’information de CVs avec différents niveaux de granularité
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Extraction de Photos dans un fichier image séparé
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Catégorisation du champ d’occupation : classification des titres et métiers des postes occupés
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Type de langages supportés : français et anglais
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Normalisation de différents éléments parsés dans un CV (dates, lieux géographiques, niveaux d&apos;études, compétences...) en utilisant des référentiels dédiés
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Localisation d’éléments disposés dans le CV
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Nota : Dans le cadre du Parsing de Cvs, Xtramile ne conserve aucune donnée.
                </p>

                <p>
                  <strong>24.6 Outil AI Scoring (sur option)</strong>
                </p>
                <p>
                  Estimation du score qualité de candidats pertinents sur la base d’offres d’emploi données et selon des critères de compréhension fine des éléments mis en avant dans les documents d’offres d’emploi et de profils de candidats.
                </p>

                <p>
                  <strong>24.7 Outil X-Landing Page (sur option)</strong>
                </p>
                <p>
                  Mise à disposition d’une page carrière pour exposer vos offres sur Internet et capter des candidatures. Cette option est utile pour les clients qui ne disposent pas d’un site carrière.
                </p>

                <p>

                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>25. Annexe 2 – Données Personnelles</strong>
                </p>

                <p>
                  <strong>25.1 Description du traitement des données effectués par nous pour votre compte</strong>
                </p>

                <table width={"100%"} cellPadding={6} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={204} />
                    <col width={374} />
                  </colgroup>
                  <tbody>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Finalités du traitement de données à caractère personnel
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Fourniture des Services décrits au sein des Conditions Générales
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Nature des opérations de traitement
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p
                        className="western"

                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Collecte, organisation, structuration, conservation, utilisation,
                        communication par transmission et diffusion.
                      </p>
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        <br />
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Type de données à caractère personnel traitées
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p
                        className="western"

                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Selon votre choix&nbsp;:
                      </p>
                      <ul>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            Nom
                          </p>
                        </li>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            Prénom
                          </p>
                        </li>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            Email
                          </p>
                        </li>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            Fonction
                          </p>
                        </li>
                        <li>
                          <p  style={{ orphans: 2, widows: 2 }}>
                            Numéro de téléphone
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                          Catégories de personnes concernées
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Utilisateurs
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Durée du traitement
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Durée des Conditions Générales
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <p>
                  <strong>25.2 Liste des Sous-traitants ultérieurs autorisés</strong>
                </p>

                <table width={"100%"} cellPadding={7} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={108} />
                    <col width={128} />
                    <col width={90} />
                    <col width={220} />
                  </colgroup>
                  <tbody>
                  <tr valign="top">
                    <td
                      width={108}
                      height={34}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Sous-traitants ultérieurs autorisés
                      </p>
                    </td>
                    <td
                      width={128}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Activités de traitement sous-traitées
                      </p>
                    </td>
                    <td
                      width={90}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Localisation des traitements
                      </p>
                    </td>
                    <td
                      width={220}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Garanties appropriées mises en place en cas de transfert de
                        données hors UE
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={108}
                      height={23}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Microsoft
                      </p>
                    </td>
                    <td
                      width={128}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Hébergement des données
                      </p>
                    </td>
                    <td
                      width={90}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Europe
                      </p>
                    </td>
                    <td
                      width={220}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        N/A
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={108}
                      height={22}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Google
                      </p>
                    </td>
                    <td
                      width={128}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Hébergement des données
                      </p>
                    </td>
                    <td
                      width={90}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Europe
                      </p>
                    </td>
                    <td
                      width={220}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        N/A
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className={styles.text}>
              <p className={styles.titleBlock}>
                <strong>1. Who are we ?</strong>
              </p>
              <div>
                <p>
                  We are <strong>XTRAMILE</strong>, a simplified joint stock company registered with the Metz Trade and Companies Register under number 808 982 037. You can contact us at the following email address: <a href={"mailto:xtramile-clients@myxtramile.com"}>xtramile-clients@myxtramile.com</a>
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>2. What do we offer?</strong>
                </p>
                <p>
                  We support our professional clients (« <strong>You</strong> » or the « <strong>Client</strong> ») in automating their recruitment process.
                </p>
                <p>
                  To this end, we provide them with the HR Trading Desk platform, accessible via the website <a href={"https://www.xtramile.io"} target={"_blank"} rel="noreferrer">www.xtramile.io</a> (the « <strong>Plateform</strong> »), a comprehensive software for distributing multi-channel job offers (job boards, career sites, metasearch engines, social networks and display channels) accompanied by data analysis tools (the « <strong>Tools</strong> ») to help them measure the performance of each channel used (together the « <strong>Services</strong> »).
                </p>
                <p>
                  The technical and functional characteristics of the Platform are described in <a href={"#appendix1"}>Appendix 1</a>.
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>
                    3. What documents govern our contractual relationship?
                  </strong>
                </p>

                <p>
                  Our contractual relationship is governed, in descending hierarchical order, by the following documents:
                </p>

                <table width={"100%"} cellPadding={7} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={145} />
                    <col width={429} />
                  </colgroup>
                  <tbody>
                  <tr valign="top">
                    <td
                      width={145}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        The «&nbsp;<b>Commercial Proposal</b>»
                      </p>
                    </td>
                    <td
                      width={429}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"
                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        It is established on the basis of your needs and indicates in particular the content of the Services subscribed to, their price, as well as its period of validity.
                      </p>
                      <ul style={{ padding: "0in 0.38in" }}>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                            You must accept it in writing (including by email) within 30 days of its issue. Otherwise, it is void. This acceptance constitutes acceptance of the General Conditions in their version in force on the date of the Commercial Proposal.
                          </p>
                        </li>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                            In the event of any contradiction, the Commercial Proposal shall prevail over the General Conditions and the Insertion Order.
                          </p>
                        </li>
                        <li>
                          <p style={{ orphans: 2, widows: 2 }}>
                            In the event of a contradiction, the most recent Commercial Proposal prevails over the oldest.
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={145}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        The «&nbsp;<b>General Conditions</b>&nbsp;»
                      </p>
                    </td>
                    <td
                      width={429}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"
                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        They define:&nbsp;:
                      </p>
                      <ul style={{ padding: "0in 0.38in" }}>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                            The terms of use of our Services,
                          </p>
                        </li>
                        <li>
                          <p style={{ orphans: 2, widows: 2, marginBottom: "0in" }}>
                            Our obligations and yours.
                          </p>
                        </li>
                      </ul>
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        You can find them via a direct link at the bottom of the Platform page.
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={145}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"

                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Purchase orders
                      </p>
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        or insertion orders (the « <b>Insertion Orders</b> »)
                      </p>
                    </td>
                    <td
                      width={429}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p
                        className="western"
                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        The Client may actually order the Services by placing Insertion Orders by email and, where applicable, by API request. The Client will then be asked to provide certain information, including: the Package(s) chosen or the additional Tools chosen.
                      </p>
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        The Commercial Proposal can therefore be followed by the issue of an Insertion Order which must be the subject of quotes which must be validated by the parties.
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>4. What other terms and conditions do you need to agree to in order to use our Services?</strong>
                </p>
                <p>
                </p>

                <p>All payments made through our Platform are handled by the payment service provider indicated on the Platform (the « <strong>Payment Service Provider</strong> »).</p>

                <p>You contract directly with the Payment Service Provider regarding the implementation of these payments, by accepting its general conditions, via a checkbox on the Platform.</p>

                <p>If the Payment Service Provider refuses or terminates your subscription, you cannot/no longer use our Services.</p>

                <p>Conversely, the end of our contractual relationship results in the termination of your contract with the Payment Service Provider.</p>

                <p>In the event of any contradiction between the Payment Service Provider&apos;s general terms and conditions and our General Terms and Conditions, the latter shall prevail.</p>

                <p>You expressly mandate us to transmit to the Payment Service Provider all your instructions relating to payments made on the Platform.</p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>5. What are the conditions for accessing our Services?</strong>
                </p>

                <p>
                  <strong>(i)</strong>You are:
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        A <strong>natural person</strong> with full legal capacity,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Or a <strong>legal entity</strong> acting through a natural person with the power or authorization required to contract in your name and on your behalf.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>(ii)</strong><strong>You have the status of professional</strong>, understood as any natural or legal person acting for purposes falling within the framework of their commercial, industrial, craft, liberal or agricultural activity, including when they act in the name or on behalf of another professional.
                </p>

                <p>
                  <strong>(iii)</strong>You are able to guarantee your access to the Platform which requires the following minimum technical configuration:
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        The Platform is optimized for a screen resolution of 1366 x 768 pixels,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        For Internet browsers: Microsoft Edge, Google Chrome, Firefox and Safari in versions supported by their publishers and released within the last 12 months,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        A means of connecting to the Internet allowing access to the Platform.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>6. How to subscribe to our Services?</strong>
                </p>
                <p>
                  You can subscribe to our Services:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Either by completing the form provided for this purpose on the Platform and providing us with all the information marked as mandatory.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Either by contacting us directly using the contact details mentioned in the article “Who are we?”. We will send you a Commercial Proposal, in accordance with your needs.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  After validation of the Commercial Proposal, registration automatically results in the opening by us of an account in your name (the «<strong>Account</strong>») on the Platform which allows you to access our Services using your login ID and password.
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>7. How can your users use our Services?</strong>
                </p>
                <p>Once your Account has been created, we proceed to configure the Platform under the conditions provided in the Commercial Proposal.</p>

                <p>If you have subscribed to a “self-managed” Offer, once the configuration has been carried out by us, you can freely create accesses for users (the «<strong>Users</strong>») within the limit of the number provided for in the Commercial Proposal.</p>

                <p>You are solely responsible for creating access for Users and their personal use of the Platform.</p>

                <p>If you have subscribed to a « managed » Offer, once the configuration has been completed by us, our teams will take control of the use of the Platform, via the trader who will have been assigned to you to support you in the « managed » Offer subscribed to (the « <strong>Trader</strong> »). You do not need to create access for your Users.</p>

                <p>
                  According to what is provided for in the Commercial Proposal, access to the Services is made:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        By going directly to the Platform, and/or
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Through an API that we make available to you and that you must integrate into your IT system. The access link to the API and the related integration documentation are indicated on the Platform. It is specified that the integration of the API into your IT system is carried out under your sole responsibility, and/or
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        By any useful means that we deem appropriate.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>8. What are our services?</strong>
                </p>
                <p>
                  <strong>8.1 Our Services</strong>
                </p>
                <p>
                  Before using our Services, you acknowledge:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Have read the characteristics and constraints, particularly technical, of our Platform, reproduced in Appendix 1.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        That access to our Platform and the implementation of the Services requires being connected to the internet and that the quality of the Services depends on this connection, for which we are not responsible.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  As part of the Services to which you have subscribed, you have access to all or part of the following Tools:
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        <strong>AI Job Broadcast Classic Tool</strong> : publish job offers on one or more channels (job boards, metasearch engines and display channels) free or paid for 1 to 30 days. This Tool is offered in “Self-managed” mode only: you use the Tool to broadcast and manage your job publications.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        <strong>AI Job Broadcast Premium Tool</strong> : The AI Job Broadcast Premium Tool is software that automatically manages the distribution of job offers, conducts awareness campaigns and targets candidates on recruitment sites, social networks and online advertising (the «<strong>Campaigns</strong>»), while managing publication budgets and the performance of these publications.
                      </span>
                    </p>

                    <p>
                      <strong>AI Job Broadcast Premium Tool</strong> is offered in two modes:
                    </p>
                    <ul className={styles.listEL}>
                      <li>
                        <p>
                      <span>
                        «Self-managed»: You use the Tool to distribute and manage your offer publications, your campaigns and your budgets.
                      </span>
                        </p>
                      </li>
                      <li>
                        <p>
                      <span>
                        « Managed » : we can, via one of our Traders, operate programmatic campaigns on the Platform on your behalf and configure the channels to be used, the amounts to be allocated to the channels, the technical operations to be carried out and the statistics to be collected. This configuration will be carried out under the conditions provided for in the Commercial Proposal and within the budget limit indicated in this same Commercial Proposal.
                      </span>
                        </p>
                      </li>
                    </ul>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>HR Analytics & BI Tool</strong> : consultation and exploration of your data resulting from the use of the Services, in the form of dashboards, graphs and data exploration functionalities.
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>AI Predictive HR Analytics Tool</strong> : A tool for viewing cost per application (CPA) statistics for a given job posting, based on the job&apos;s key features. View and explore the various values using dashboards, charts, and data mining features.
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>AI CV Parsing Tool (optional)</strong> : Transformation of candidate CVs into an analyzable file format or a set of data that can be recovered for computer processing by a third party (organized JSON format)
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>AI Scoring Tool (optional)</strong> : Estimation of the quality score of relevant candidates based on given job offers and according to criteria for a detailed understanding of the elements highlighted in job offer documents and candidate profiles.
                        </span>
                    </p>
                  </li>

                  <li>
                    <p>
                        <span>
                          <strong>X-Landing Page Tool</strong> : Provision of a career page to display offers on the Internet and attract applications.
                        </span>
                    </p>
                  </li>
                </ul>

                <p>
                  We reserve the right to offer any other Service.
                </p>

                <p>
                  Any request to modify the Services subscribed to must be the subject of an additional Commercial Proposal.
                </p>

                <p>
                  <strong>8.2 Platform Access License: Subscription</strong>
                </p>
                <p>
                  We offer access to the Services and the Platform in the form of an annual subscription (the «<strong>Subscription</strong>»). The Commercial Proposal describes the scope made available, in particular the number of users and the Tools included in the Subscription.
                </p>

                <p>
                  <strong>8.3 Token Consumption</strong>
                </p>

                <p>In addition to the Subscription described above, the Client must order credits (or Tokens) to implement actions for publishing offers and/or parsing CVs.</p>

                <p>We offer our Multicast and CV Parsing Services in the form of an annual package (the «<strong>Package</strong>») which entitles the Client to consume a given number of credits (Tokens) defined according to the Package subscribed to by the Client (the «<strong>Tokens</strong>»).</p>

                <p>The nature of the Plan subscribed to is specified in the Commercial Proposal. A multi-broadcast Token allows you to publish a job offer on a channel for a period of one month. A CV parsing Token allows you to analyze a CV, i.e. a document as described in Appendix 1.a.</p>

                <p>The number of Tokens corresponding to the Plan subscribed to is credited to him in full upon subscription to his Plan.</p>

                <p>The Customer is free to consume Tokens as often as he wishes, it being specified that all Tokens not consumed on the day of renewal of the Package are permanently lost.</p>

                <p>We are committed to providing you with regular reports allowing you to maintain visibility over your Token consumption.</p>

                <p>Any consumption of Tokens beyond the limit provided for in the Plan subscribed to will be subject to an additional invoice which will be sent to you by any useful means.</p>

                <p>
                  <strong>8.4 Mandate</strong>
                </p>

                <p>
                  By accepting the Commercial Proposal and these General Conditions, the Client expressly mandates us to implement all elements necessary for the performance of the Services as indicated in the Commercial Proposal.
                </p>

                <p>
                  <strong>8.5 Our additional services</strong>
                </p>

                <p>
                  <strong>8.5.1 On-boarding</strong>
                </p>
                <p>
                  Once you have accepted these terms and conditions, we propose to configure your environment on our Platform. The terms and conditions for performing this service and its scope are specified in the Commercial Proposal.
                </p>

                <p>
                  <strong>8.5.2 Training</strong>
                </p>
                <p>
                  Once you have accepted this document, we undertake to provide you with initial training on how to use the Platform. This training may be conducted via videoconference or in person, depending on our capabilities. The terms and conditions for conducting this training, as well as the number of sessions offered, will be specified in the Commercial Proposal.
                </p>
                <p>
                  We may also provide you with additional training during the performance of the Services, upon your request using the contact details provided in the “Who are we?” section. As additional training is not included in your Subscription, we will provide you with an additional commercial proposal which must be accepted by you before any training begins.
                </p>

                <p>
                  <strong>8.5.3 Maintenance</strong>
                </p>
                <p>
                  You benefit from corrective and evolutionary maintenance during the duration of the Services.
                </p>
                <p>
                  Access to the Platform may be limited or suspended for planned maintenance reasons. We undertake to inform you at least 24 hours in advance, by any written means, and to make our best efforts to ensure that these operations do not exceed 8 hours and are carried out outside business hours, i.e., Monday to Friday from 8 a.m. to 6 p.m., Paris time, France.
                </p>

                <p>
                  <strong>Evolutionary Maintenance</strong>
                </p>
                <p>
                  During the duration of the Services, you benefit from progressive maintenance, namely:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Improvements to the Platform’s functionalities and/or technical facilities used within the Platform aimed at introducing minor extensions (the «<strong>Updates</strong>»). We may carry them out automatically and without prior notice.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Additions of new features to the Platform and/or technical installations used within the Platform (the «<strong>New Versions</strong>»). We will inform you of any New Version at least 5 working days before its installation. Not included in the New Versions are the compliance of the Platform so that it meets the regulatory specificities applicable to the Client’s activity and/or its regulated sector of activity, which may be the subject of a specific quote.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  When we add a new Tool to our Services catalog, it is not part of the Evolutionary Maintenance and will be offered to our customers as an additional option subject to a Commercial Proposal.
                </p>


                <p>
                  <strong>Corrective maintenance</strong>
                </p>
                <p>
                  We make our best efforts to provide you with corrective maintenance to correct any malfunctions or bugs found on the Platform.
                </p>
                <p>
                  These malfunctions or bugs (the «<strong>Anomalies</strong>») are divided into 3 categories:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        « Critical Anomaly » : makes any use of the Services impossible,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        « Major Anomaly » : reduces the use of the Services by preventing the use of certain essential functionalities,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        « Minor Anomaly » : prevents you from using one or more non-essential features of the Services.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  You can report any Anomaly to us by contacting our technical support at the following address: <a href={"https://xtramile.atlassian.net/servicedesk/customer/portals"}>https://xtramile.atlassian.net/servicedesk/customer/portals</a> , making every effort to provide as much information as possible (the « <strong>Maintenance Request</strong> »).
                </p>

                <p>
                  Our technical support is open Monday to Friday excluding public holidays in France (the «<strong>Business Days</strong>») from 9 a.m. to 6 p.m., Paris time, France, (the «<strong>Business Hours</strong>»).
                </p>

                <p>
                  We will inform you of the origin of the Anomaly by email.
                </p>

                <p>
                  If the Platform is not the cause of the Anomaly, and in particular if it results from the actions of a third party without any breach on our part of our obligations, no maintenance will be carried out and we cannot be held liable in this regard.
                </p>

                <p>
                  If the Platform is the cause of the Anomaly, we undertake to correct it within the following timeframes:
                </p>

                <table width={"100%"} cellPadding={7} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={126} />
                    <col width={207} />
                    <col width={189} />
                  </colgroup>
                  <tbody>
                  <tr>
                    <td
                      width={126}
                      height={8}
                      style={{
                        background: "#d0cece",
                        border: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p className="western">
                        Qualification
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        background: "#d0cece",
                        border: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p className="western">
                        Processing time
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        background: "#d0cece",
                        border: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p className="western">
                        Correction deadline
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={126}
                      height={28}
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p
                        className="western"

                        style={{ marginBottom: "0in" }}
                      ></p>
                      <p className="western" >
                        Critical Anomaly
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Within two (2) Business Hours following the Maintenance Request.
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        borderTop: "1px solid #000000",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Within 24 Business Hours (3 Business Days) following the Processing Time.
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={126}
                      height={28}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p
                        className="western"

                        style={{ marginBottom: "0in" }}
                      ></p>
                      <p className="western" >
                        Major Anomaly
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Within 24 Business Hours (3 Business Days) following the Maintenance Request.
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Within 5 Working Days following the Processing Time.
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={126}
                      height={27}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "1px solid #000000",
                        borderRight: "1px solid #000000",
                        padding: "0in 0.28in"
                      }}
                    >
                      <p
                        className="western"

                        style={{ marginBottom: "0in" }}
                      ></p>
                      <p className="western" >
                        Minor Anomaly
                      </p>
                    </td>
                    <td
                      width={207}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Within 48 Business Hours (6 Business Days) following the Maintenance Request.
                      </p>
                    </td>
                    <td
                      width={189}
                      style={{
                        borderTop: "none",
                        borderBottom: "1px solid #000000",
                        borderLeft: "none",
                        borderRight: "1px solid #000000",
                        paddingTop: "0in",
                        paddingBottom: "0in",
                        paddingLeft: "0.28in",
                        paddingRight: "0.28in"
                      }}
                    >
                      <p className="western" >
                        Within 10 Working Days following the Processing Time.
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <p>
                  The end of the intervention will be confirmed by email.
                </p>

                <p>
                  You acknowledge and agree that we are not required to provide any maintenance in the following cases:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Refusal on your part to collaborate with us in resolving the Anomalies and in particular to respond to questions and requests for information;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Use of the Platform in a manner not in accordance with its purpose or documentation;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Unauthorized modification of the Platform by you, Users or any other third party;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Failure to comply with your obligations under these terms;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Installation of any software packages, software or operating system not compatible with the Platform;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Failure of electronic communications networks;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Willful act of degradation, malice, sabotage;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Deterioration due to force majeure as defined herein or to improper use of the Platform.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>8.5.4 Accommodation</strong>
                </p>
                <p>
                  We ensure, under the terms of an obligation of means, the hosting of the Platform, as well as the data entered on the Platform, on our servers or through a professional hosting provider, and on servers located in a territory of the European Union.
                </p>

                <p>
                  <strong>8.5.5 Technical assistance</strong>
                </p>
                <p>
                  If you encounter any difficulties when using our Services, you can contact us using the contact details mentioned in the article “Who are we?”.
                </p>
                <p>
                  We will respond as quickly as possible depending on the nature of the request, it being understood that technical support is open during Business Hours.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>9. For how long are you subscribing to our Services?</strong>
                </p>
                <p>
                  The Services are subscribed to in the form of a Subscription with one or more Package(s).
                </p>
                <p>
                  The Subscription begins on the day of subscription for an initial period of one year, unless otherwise specifically provided in the Commercial Proposal (the «<strong>Initial Subscription Period</strong>»).
                </p>
                <p>
                  Any Package subscribed to in addition to the Subscription begins on the day of subscription for an initial period of one year, unless specifically provided in the Commercial Proposal (the «<strong>Initial Package Period</strong>»).
                </p>
                <p>
                  The Initial Subscription Period and the Initial Package Period are hereinafter referred to as the «<strong>Initial Periods</strong>»).
                </p>
                <p>
                  The Packages and the Subscription are then tacitly renewed for periods of the same duration as their respective Initial Period (hereinafter the «<strong>Subsequent Period(s)</strong>»), unless termination is made at the latest:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        3 months before the end of the Initial Period;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        3 months before the end of a Subsequent Period.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  The Initial Period and Subsequent Periods are hereinafter collectively referred to as the «<strong>Period</strong>».
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>10. What are our financial conditions?</strong>
                </p>

                <p>
                  <strong>10.1 What are the prices of our Services?</strong>
                </p>
                <p>
                  The prices of the Subscription and/or Package to which you have subscribed are indicated in the Commercial Proposal.
                </p>
                <p>
                  Any Period started is due in full.
                </p>
                <p>
                  As part of the Subscription to the AI ​​Job Broadcast Premium Tool in “Managed” mode, it is specified, as required, that the budget allocated to the Services is indicated in the Commercial Proposal. As an exception, the Quote will specify the amounts allocated to each Campaign and which will impact the budget.
                </p>
                <p>
                  In the event that the entire budget has been used up before the end of the Period, the Customer may top up their Account at any time. Any budget not used up at the end of the Period will not be refunded in the event of termination of this Agreement and will be carried over to the following period in the form of a monetary reduction.
                </p>
                <p>
                  We are free to offer promotional offers or price reductions.
                </p>

                <p>
                  <strong>10.2 What are our billing and payment terms?</strong>
                </p>
                <p>
                  We will send you an invoice per Period by any useful means.
                </p>
                <p>
                  Unless otherwise stated in the Commercial Proposal, payments are made by bank transfer to the details indicated on our invoices and within the timeframes indicated in the Commercial Proposal.
                </p>
                <p>
                  You guarantee that you have the necessary authorizations to use this payment method.
                </p>

                <p>
                  <strong>10.3 What are the consequences of late or non-payment?</strong>
                </p>
                <p>
                  In the event of non-payment or late payment, we reserve the right, from the day after the due date shown on the invoice, to:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Declare the forfeiture of the term of all sums that you owe us and their immediate payment,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Immediately suspend the current Services until payment of all amounts due,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Charge us late payment interest equal to 3 times the legal interest rate, based on the amount of sums not paid on the due date and a fixed compensation of 40 euros for recovery costs, without prejudice to additional compensation if the recovery costs actually incurred are higher than this amount.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>10.4 Do you have a right of withdrawal?</strong>
                </p>
                <p>
                  You have a right of withdrawal if you are a professional who (i) has 5 employees or less, (ii) purchases a good or service that does not fall within your main field of activity (i.e. does not directly or indirectly affect the Services) and (iii) the contract is concluded “off-premises”, namely:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        In a place, different from our premises, where we were present together physically and simultaneously,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        At your premises or by means of a remote communication technique, immediately after we have solicited you personally and individually (i) in a place other than our premises and (ii) where we were present together physically and simultaneously,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        During an excursion we organized to promote our Services.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  This right of withdrawal is 14 calendar days from the signing of the Commercial Proposal. You can exercise this right free of charge by sending us, before the end of the period, to the contact details mentioned in the article « Who are we »?, an unambiguous declaration expressing your wish to withdraw.
                </p>
                <p>
                  If you exercise your right of withdrawal, we will reimburse you for all payments received, using the same means of payment as you used (unless you expressly agree to a different means), without undue delay and at the latest within 14 calendar days from the day on which we were informed of your wish to withdraw.
                </p>
              </div>
              <div>
                <p className={styles.titleBlock}>
                  <strong>11. What are our respective intellectual property rights?</strong>
                </p>

                <p>
                  <strong>11.1 Our intellectual property rights</strong>
                </p>
                <p>
                  The Platform is our property, as are the software, infrastructure, databases and content of all kinds (texts, images, visuals, music, logos, brands, etc.) that we operate, as well as all Usage Data (see below) resulting therefrom. They are protected by all intellectual property rights or database producer rights in force. The license that we grant you does not entail any transfer of ownership.
                </p>
                <p>
                  Any disassembly, decompilation, decryption, extraction, reuse, copying and more generally, any act of reproduction, representation, distribution and use of any of these elements, in whole or in part, when these acts are not made necessary by the execution of the General Conditions, or when they have not been previously authorized by XTRAMILE, are strictly prohibited and may be subject to legal action.
                </p>
                <p>
                  You and the Users benefit from a non-exclusive and non-transferable SaaS license to use the Platform for the duration provided for in the article «For how long are you subscribing to our Services?
                </p>
                <p>
                  Unless otherwise stated in the Commercial Proposal and with your agreement, we may use our respective names, brands and logos and refer to our respective platforms, as commercial references, for the duration of our contractual relationship and 5 years beyond.
                </p>
                <p>
                  All data generated by the use of our Platform by Customers (the « <strong>Usage Data</strong> ») is our property. For example, this Usage Data includes (but is not limited to) the number of offers processed, the channels used, the job types related to the offers, the geographical characteristics of the publications and the offers, the dates of the various publication events, campaigns, applications, and the number of applications. We guarantee that the Usage Data remains anonymous and, as such, no personal data within the meaning of the Applicable Regulations, nor any Customer name is included in the Usage Data.
                </p>

                <p>
                  <strong>11.2 Your intellectual property rights</strong>
                </p>
                <p>
                  The systems, software, structures, infrastructures, databases and content of any nature (the «<strong>Content</strong>») that you use in the context of your activity, and that you communicate to us for the purpose of providing the Services, remain your property and are protected by all intellectual property rights or rights of database producers in force.
                </p>
                <p>
                  Any disassembly, decompilation, decryption, extraction, reuse, copying and more generally, any act of reproduction, representation, distribution and use of any of these elements, in whole or in part, when these acts are not made necessary by the execution of the General Conditions, or when they have not been previously authorized by the Client, are strictly prohibited and may be subject to legal action.
                </p>
                <p>
                  You are only granted a license to use the elements to which you may have access or which we transmit to you, for the duration of the Contract and for the sole purpose of executing it.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>12. What are your obligations and what are you responsible for?</strong>
                </p>

                <p>
                  <strong>12.1 Regarding the provision of information</strong>
                </p>
                <p>
                  You agree to provide us with all the information necessary for the subscription and use of the Services.
                </p>

                <p>
                  <strong>12.2 Regarding your Account</strong>
                </p>
                <p>
                  You :
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Guarantee that the information transmitted in the form is accurate and agree to update it,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Acknowledge that this information constitutes proof of your identity and is binding upon you upon validation,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        You are responsible for maintaining the confidentiality and security of your username and password. Any access to the Platform using these is deemed to have been made by you.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  You must immediately contact us using the contact details provided in the &#34;Who are we?&#34; section if you become aware that your Account has been used without your knowledge. You acknowledge that we will be entitled to take all appropriate measures in such cases.
                </p>
                <p>
                  You are solely responsible for setting User access rights.
                </p>

                <p>
                  <strong>12.3 Regarding the use of the Services</strong>
                </p>
                <p>
                  You are responsible for your use of the Services and any information you share in connection therewith. You are also responsible for the use of the Services and any information shared by Users. You agree that the Services will be used exclusively by you and/or Users, who are subject to the same obligations as you in their use of the Services.
                </p>
                <p>
                  You agree not to misuse the Services for purposes other than those for which they were designed, and in particular to:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Carry out any illegal or fraudulent activity,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Disturb public order and morality,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Harm third parties or their rights in any way,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Violate any contractual, legislative or regulatory provision,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Carry out any activity likely to interfere with the computer system of a third party, in particular for the purpose of violating its integrity or security,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Carry out maneuvers aimed at promoting your services and/or sites or those of a third party,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Assisting or inducing a third party to commit one or more of the acts or activities listed above.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  You also prohibit yourself from:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Copy, modify or divert any element belonging to us or any concept that we exploit within the framework of the Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Engage in any behavior that may interfere with or divert our computer systems or undermine our computer security measures,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Harm our financial, commercial or moral rights and interests,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Market, transfer or otherwise provide access to the Services, information hosted on the Platform or any element belonging to us.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  You are solely responsible for the Content of any nature that you distribute within the framework of the Services and in particular for the job offers and training offers that you distribute on the Platform or that you transmit to us for distribution within the framework of the « Managed » Offer.
                </p>

                <p>
                  You agree that the Content posted on the Platform is made public by default and may be viewed by other users of the Platform.
                </p>

                <p>
                  You are prohibited from distributing any Content (this list is not exhaustive):
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Harming public order and morality (pornographic, obscene, indecent, shocking or unsuitable for a family audience, defamatory, insulting, violent, racist, xenophobic or revisionist),
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Infringing the rights of third parties (infringing content, infringement of personality rights, etc.) and more generally violating a contractual, legislative or regulatory provision,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Harmful to third parties in any way,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        False, misleading or offering or promoting illegal, fraudulent or deceptive activities,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Harmful to third-party computer systems.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  You are responsible for the relationships you may establish with other users of the Platform. You agree to act with discernment and respect the usual rules of politeness and courtesy in your interactions with other users.
                </p>

                <p>
                  You guarantee us against any claim and/or action that may be brought against us as a result of the breach of any of your obligations. You will compensate us for the loss suffered and reimburse us for any sums that we may have to bear as a result.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>13. What are our obligations and what are we responsible for?</strong>
                </p>
                <p>
                  We undertake to provide the Services diligently; it being understood that we are bound by an obligation of means. We also undertake to comply with the regulations in force.
                </p>

                <p>
                  <strong>13.1 Regarding the quality of our Services</strong>
                </p>
                <p>
                  We freely choose the practical and organizational methods by which we carry out the Services, subject to carrying them out in accordance with the rules of the art.
                </p>
                <p>
                  We are therefore the sole judges of the material resources that we decide to allocate to their realization. We are entirely and exclusively responsible for the means and, more generally, the practical methods of their realization, over which we ensure complete control. For the purposes of the execution of the Services, we may be required to use specific material resources, the use of which will be decided by mutual agreement between the Parties.
                </p>
                <p>
                  We make our best efforts to provide you with quality Services. To this end, we regularly carry out checks to verify the operation and accessibility of our Services and may therefore carry out planned maintenance under the conditions specified in the “Maintenance” article.
                </p>
                <p>
                  However, we are not responsible for any temporary difficulties or impossibilities in accessing our Services which may be due to:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Circumstances external to our network (and in particular the partial or total failure of your servers),
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Failure of equipment, wiring, services or networks not included in our Services or which are not under our responsibility,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        From the interruption of Services due to telecom operators or internet access providers,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        From your intervention, in particular via an incorrect configuration applied to the Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        From a case of force majeure.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  We are responsible for the operation of our servers, the outer limits of which are formed by the connection points.
                </p>

                <p>
                  Furthermore, we do not guarantee that the Services, which are subject to constant research to improve their performance and progress, will be completely free from errors, defects or faults.
                </p>

                <p>
                  You acknowledge and agree that the Services provided by the Tools are only suitable for:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Computer-edited content (i.e. not handwritten);
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Data written in the Latin alphabet and/or containing decimal numbering;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Any other details specified in the Commercial Proposal.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  We do not guarantee the accurate extraction of data and information from Content transmitted using systems and/or formats other than those mentioned above. Furthermore, we do not guarantee the accuracy of the marking or entry of data and information contained in the Content. The Customer acknowledges and accepts that Content containing illegible data may not be processed correctly.
                </p>

                <p>
                  <strong>13.2 Regarding the Platform’s service level guarantee</strong>
                </p>
                <p>
                  We make our best efforts to maintain access to the Platform 24/7 except in the event of planned maintenance under the conditions defined in the “Maintenance” article or force majeure.
                </p>

                <p>
                  <strong>13.3 Regarding the backup of data on the Platform</strong>
                </p>
                <p>
                  We make every effort to back up all data produced and/or entered by/on the Platform. Except in the event of proven errors on our part, we are nevertheless not responsible for any loss of data during maintenance operations.
                </p>

                <p>
                  <strong>13.4 Regarding data storage and security</strong>
                </p>
                <p>
                  We provide you with sufficient storage capacity for the operation of the Services. We make our best efforts to ensure data security by implementing measures to protect infrastructure and the Platform, detect and prevent malicious acts, and recover data.
                </p>

                <p>
                  <strong>13.5 Regarding the publication of Content</strong>
                </p>
                <p>
                  We act as a hosting provider for the Content you upload. Accordingly, we are not responsible for this Content. If we receive a notification regarding illegal Content, we will act promptly to remove it or make it inaccessible, and we may take the measures described in the article « What are the sanctions in the event of failure to comply with your obligations? ».
                </p>

                <p>
                  <strong>13.6 Regarding the connection between users</strong>
                </p>
                <p>
                  We act as an intermediary in your dealings with other users. We therefore cannot be held liable in connection with your dealings with other users, nor can we be a party to any potential disputes. In this regard, we do not guarantee that candidates will find the position that best meets their needs, as we are not involved in the application process.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>14. To what extent can you hold us liable?</strong>
                </p>
                <p>
                  Our liability is limited to only proven direct damages that you suffer as a result of using our Services. In any event, XTRAMILE&apos;s liability will be limited to a total amount that may not exceed 20% of the annual price of the Services subscribed to.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>15. What are the methods of proof accepted between us?</strong>
                </p>
                <p>
                  Proof can be established by any means.
                </p>
                <p>
                  You are informed that the messages exchanged through our Platform as well as the data collected on the Platform and our IT equipment constitute the main mode of proof accepted, in particular to demonstrate the reality of the Services provided and the calculation of their price.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>16. How is personal data processed in the Services?</strong>
                </p>

                <p>
                  <strong>16.1 General provisions</strong>
                </p>
                <p>
                  We mutually undertake, each for what concerns us, to comply with the regulations applicable to personal data and in particular with the General Data Protection Regulation (EU regulation 2016/679 of the European Parliament and of the Council of April 27, 2016) and with the law relating to Information Technology and Civil Liberties of January 6, 1978 in its latest version in force (hereinafter together referred to as the « <strong>Applicable Regulations</strong> »).
                </p>

                <p>
                  <strong>16.2 When we collect your personal data for business management purposes in our capacity as data controller</strong>
                </p>
                <p>
                  We act as a data controller within the meaning of the applicable regulations for processing related to business management. In this context, your personal data is retained for the period strictly necessary to manage our contractual relationship with you. Our staff, our audit departments (including statutory auditors), and our subcontractors may have access to the personal data collected.
                </p>
                <p>
                  These treatments are necessary for the proper execution of this Contract. It may give rise to the exercise by the persons concerned of their right (i) to obtain communication and, where applicable, the rectification or deletion of data concerning them, (ii) to request the erasure or limitation of the processing, (iii) to oppose the processing for legitimate reasons, (iv) to request the portability of data concerning them, in order to recover and retain them, and (v) to lodge a complaint with a competent supervisory authority.
                </p>

                <p>
                  <strong>16.3 When we collect Users&#39; personal data on your behalf in our capacity as a processor</strong>
                </p>
                <p>The purpose of this clause is to define the conditions under which we undertake, on your behalf, the processing of personal data described below.</p>

                <p>
                  <strong>16.3.1 Description of the outsourced processing</strong>
                </p>
                <p>
                  As part of the Services, we process personal data as a processor within the meaning of the Applicable Regulations in your name and on your behalf. You act as the data controller within the meaning of the Applicable Regulations. The characteristics of the processing are described in Appendix 2 of the General Conditions.
                </p>

                <p>
                  <strong>16.3.2 Our obligations to you</strong>
                </p>
                <p>
                  <strong>Data processing:</strong>
                </p>
                <p>
                  We undertake to process personal data only for the purposes listed in Appendix 2 and in accordance with your documented instructions, including with regard to the transfer of data outside the European Union. We undertake to inform you if, in our opinion, an instruction constitutes a breach of Applicable Regulations. In addition, if we are required to transfer data to a third country or an international organization under the law applicable to these Terms and Conditions, we will inform you of this legal obligation before processing, unless the relevant law prohibits such information for important reasons of public interest.
                </p>

                <p>
                  <strong>Data security and confidentiality:</strong>
                </p>
                <p>
                  We are committed to implementing appropriate technical and organizational measures to ensure the security and integrity of personal data, their backup, and the restoration of their availability in the event of a physical or technical incident. We also ensure that persons authorized to process personal data are subject to the obligation to maintain their confidentiality.
                </p>

                <p>
                  <strong>Other subcontractors:</strong>
                </p>
                <p>
                  We are authorized to use the subcontractors (the «<strong>Sub-processor</strong>») listed in Appendix 1 of the General Terms and Conditions to carry out specific processing activities. In the event of a change in the list of authorized Sub-processors, we will inform you in advance and in writing. This information must clearly indicate the subcontracted processing activities, the identity and contact details of the Sub-processor. You have a period of 15 (fifteen) days from the date of receipt of this information to submit your legitimate and reasoned objections. If you do not notify us of objections after this period, you will be deemed to have accepted the use of the Sub-processor.
                </p>
                <p>
                  The Sub-processor is required to comply with the obligations of these General Terms and Conditions on your behalf and according to your instructions. It is our responsibility to ensure that the Sub-processor provides the same sufficient guarantees regarding the implementation of appropriate technical and organizational measures so that the processing meets the requirements of the Applicable Regulations. If the Sub-processor does not fulfill its data protection obligations, we remain responsible to you for the performance by the Sub-processor of its obligations.
                </p>

                <p>
                  <strong>Transfer of personal data outside the European Union:</strong>
                </p>
                <p>
                  We are authorized to transfer personal data processed under these General Conditions to countries located outside the European Union, subject to the implementation of appropriate safeguards as defined in Chapter V of the aforementioned regulation.
                </p>

                <p>
                  <strong>Assistance and Provision of Information:</strong>
                </p>
                <p>
                  We are committed to assisting you and responding as quickly as possible to any request for information sent to us by you, whether in the context of a request to exercise their rights by the persons concerned, an impact analysis or a request submitted by the data protection authorities or your data protection officer.
                </p>

                <p>
                  <strong>Notification of personal data breaches:</strong>
                </p>
                <p>
                  We undertake to notify you of any personal data breach and to provide you with any useful information and documentation to enable you, where appropriate, to notify this breach to the competent supervisory authority, as soon as possible after becoming aware of it.
                </p>

                <p>
                  <strong>Data output:</strong>
                </p>
                <p>
                  We undertake, at our discretion, to delete personal data at the end of your use of the Services or to return it to you and not to keep a copy, unless required by applicable Regulations.
                </p>

                <p>
                  <strong>Documentation :</strong>
                </p>
                <p>
                  We provide you, upon request, with all the information and documents necessary to demonstrate compliance with our obligations and to enable audits to be carried out. You therefore have the option of conducting audits once a year and at your expense in order to verify our compliance with the obligations set out in this article relating to personal data. You will inform us of the audit with a minimum notice of two (2) weeks. We reserve the right to refuse the identity of the auditor selected if they belong to a competing company. The audit must be carried out during our Business Hours and in a manner that disrupts our business as little as possible. The audit may therefore not affect in any way (i) our technical and organizational security measures deployed, (ii) the security and confidentiality of our other clients&apos; data, (iii) or the proper functioning and organization of our production. Where possible, we will agree in advance on the scope of the audit. The audit report must be sent to us so that we can formulate any observations or comments we may have in writing, which will be attached to the final version of the audit report. Each audit report will be considered confidential information. If the audit report reveals non-compliance by our company with the applicable Regulations, we undertake to reimburse you for the audit fees up to 1% of the amounts invoiced to you for the Services and, in any event, this amount may not exceed 3,000 euros excluding tax.
                </p>

                <p>
                  <strong>16.3.3 Your obligations to us</strong>
                </p>
                <p>You agree to:</p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Provide us with the personal data referred to in Appendix 1, excluding any irrelevant, disproportionate or unnecessary personal data, and excluding any “special” data within the meaning of the applicable Regulations, unless the processing justifies it, it being your responsibility to establish these justifications and to take all measures, in particular prior information, collection of consent and security, appropriate for such special data;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Collect under your responsibility, in a lawful, fair and transparent manner, the personal data that you provide to us, for the execution of the Services, and in particular, ensure the legal basis for this collection and the information due to the persons concerned;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Maintain a register of processing operations and, more generally, comply with the principles arising from the Applicable Regulations;
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Ensure, beforehand and throughout the duration of the processing, compliance with the obligations provided for by the Applicable Regulations.
                      </span>
                    </p>
                  </li>
                </ul>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>17. What are our respective confidentiality obligations?</strong>
                </p>
                <p>
                  Unless otherwise agreed in writing by the other party, we undertake to keep confidential, for the duration of our contractual relationship and for 3 years thereafter, all information relating to or held by the other party, of which we have become aware during the conclusion and execution of our contractual relationship.
                </p>
                <p>
                  This obligation does not extend to information:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Of which the receiving party was already aware,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Already public at the time of their communication or which would become so without violation of this clause,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Which would have been received from a third party in a lawful manner,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        The communication of which would be required by the judicial authorities, in application of laws and regulations or in order to establish the rights of a party within the framework of our contractual relationship.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  Confidential information may be transmitted to our respective employees, collaborators, interns, agents and co-contractors, provided that they are subject to the same obligation of confidentiality.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>18. Force majeure</strong>
                </p>
                <p>
                  We cannot be held liable for any failure or delay in the performance of our respective contractual obligations due to force majeure occurring during the term of our relationship. Force majeure includes:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Any case meeting the conditions of Article 1218 of the Civil Code and recognized by case law,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Strikes, terrorist activities, riots, insurrections, wars, government actions, epidemics, natural disasters or failure attributable to a third party telecommunications provider.
                      </span>
                    </p>
                  </li>
                </ul>
                <p>
                  If one of us is prevented from performing its obligations due to force majeure, it must inform the other party by registered letter with acknowledgment of receipt. The obligations are suspended upon receipt of the letter, and must be resumed within a reasonable time after the force majeure ceases.
                </p>
                <p>
                  We nevertheless remain bound by the performance of our respective obligations which are not affected by a case of force majeure and any payment obligation.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>19. How to terminate the Services?</strong>
                </p>
                <p>
                  The Services may be terminated no later than 3 (three) months before the end of the current Period, by:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        You, by sending us a request to the contact details mentioned in the article « Who are we ? »,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        We, by sending you an email.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  You will no longer have access to your account after the Services end. Any Token not used by the end of the Services will be permanently lost and will not be refunded.
                </p>

                <p>
                  The termination of this Agreement, whatever the cause except when it is due to a case of force majeure under the conditions defined in the article «Force Majeure», has no impact on the Insertion Orders validated by Quote which are in progress, which must be executed according to the terms provided for herein.
                </p>

                <p>
                  The termination of the General Conditions also has no impact on the provisions of these General Conditions intended to continue beyond, and in particular the articles «Intellectual Property», «Confidentiality” and this article.
                </p>

                <p>
                  Any Period started is due in full.
                </p>

                <p>
                  Termination will result in the deletion of your Account. You acknowledge and agree that upon termination of the Services, all settings you have made on the Platform will be lost.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>20. What are the penalties for failure to meet your obligations?</strong>
                </p>

                <p>
                  Payment of the price of the Services and the obligations set out in the article « What are your obligations and what are you responsible for? » constitute essential obligations.
                </p>

                <p>
                  In the event of failure to comply with these obligations, we may:
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Suspend or terminate your access to the Services,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Remove any Content related to the breach,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Publish on the Platform any information message that we deem useful,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Send you a registered letter with acknowledgment of receipt for:
                      </span>
                    </p>

                    <ul className={styles.listEL}>
                      <li>
                        <p>
                          <span>
                            Terminate our contractual relationship, the termination taking effect on the day of receipt or first presentation of this letter,
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Or to ask you to remedy the breach within a maximum period of 15 calendar days. The termination will take effect at the end of this period if the breach is not rectified.
                          </span>
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>
                      <span>
                        Notify any competent authority, cooperate with it and provide it with all information useful for the investigation and suppression of illegal or illicit activities,
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Take any legal action.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  These sanctions are without prejudice to any damages that we may claim from you.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>21. How can we change our Terms and Conditions?</strong>
                </p>

                <p>
                  We may modify our General Conditions at any time and will inform you by any written means (including by email) at least 3 months before they come into effect.
                </p>

                <p>
                  The amended General Conditions are applicable upon renewal of your Package.
                </p>

                <p>
                  If you do not accept these changes, you must terminate your Services in accordance with the terms set out in the section « How to terminate the Services ? ».
                </p>

                <p>
                  If you use our Services after our amended Terms and Conditions come into effect, we consider that you have accepted them.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>22. Electronic signature</strong>
                </p>

                <p>
                  It is understood that the Commercial Proposal, and subsequently these General Conditions, may be signed by any electronic means, we mutually recognize the reliability of the process thus giving it the same legal value as a handwritten signature within the meaning of the law.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>23. Applicable law and competent jurisdictions</strong>
                </p>

                <p>
                  Our General Terms and Conditions are governed by French law. In the event of a dispute between us, and in the absence of an amicable agreement within 2 months of the first notification, it will be subject to the exclusive jurisdiction of the courts of Metz (France), unless otherwise provided.
                </p>
              </div>

              <div>
                <p className={styles.titleBlock} id={"appendix1"}>
                  <strong>24. Appendix 1 - Functional and technical characteristics of the Platform</strong>
                </p>

                <p>
                  <strong>24.1 AI Job Broadcast Classic</strong>
                </p>
                <p>
                  The AI Job Broadcast Classic Tool allows you to automatically publish job offers on one or more channels (job boards, metasearch engines and display channels) free or paid. This Tool is offered in the « Self-managed » mode only: you use the Tool to broadcast and manage your job publications.
                </p>
                <p>
                  The Tool allows in particular to:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        To import, modify, delete, and automatically distribute offers
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        To bring offers into compliance thanks to our AI models that correct the content of offers to increase their quality, remove any discriminatory comments and prepare the quality of the content which will ensure an optimal success rate of publication on your favorite channels.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Edit a posting policy through rules governing the conditions that will automatically trigger posts (“auto posting”), as well as the target channels to use. The rules are based on any attributes of the offer
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        To automatically unpublish job offers according to the same publication/unpublication rules chosen (given date, for example)
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Save time, improve reliability and increase productivity thanks to advanced features such as duplicating offers according to their geography
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        To consult the various indicators of Token consumption and processing status on offers: imports, compliance, publication, unpublication, pause, etc.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        To consult the list of available job boards, please refer to the Public Channel Catalog.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  For partner organizations that manage several of their clients through the Xtramile Platform, it is possible to create a separate space per client (separation of data by client), thanks to the concepts of Client account and Office account.
                </p>

                <p>
                  The Tool&#39;s features are available from a user interface or from an API.
                </p>

                <p>
                  <strong>24.2 AI Job Broadcast Premium</strong>
                </p>

                <p>
                  The AI Job Broadcast Premium Tool includes all the features of the AI Job Broadcast Classic Tool plus the following features:
                </p>

                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Management of broadcast campaigns
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Management of campaign budgets.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Automatic synchronization of budgets and campaigns with partner platforms (contact us for the list of supported management platforms).
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Access to advanced publishing channels such as
                      </span>
                    </p>
                    <ul className={styles.listEL}>
                      <li>
                        <p>
                          <span>
                            Boost
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Search Ads
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Social Ads
                          </span>
                        </p>
                      </li>
                      <li>
                        <p>
                          <span>
                            Targeted Ads
                          </span>
                        </p>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>
                      <span>
                        User account management.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Additionally, the <strong>AI Job Broadcast Premium Tool</strong> is offered in two modes:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        « Self-managed » : You use the Tool to distribute and manage your offer publications, your campaigns and your budgets.
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        « Managed » : we can, via one of our Traders, operate programmatic campaigns on the Platform on your behalf and configure the channels to be used, the amounts to be allocated to the channels, the technical operations to be carried out and the statistics to be collected.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>24.3 HR Analytics & BI Tool</strong>
                </p>
                <p>
                  Consultation and exploration of your data resulting from the use of the Services, in the form of dashboards, graphs and data exploration functionalities. The Tool is structured around two main dashboards:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Analysis of offers and publications, according to several dimensions such as: time interval, distribution by distribution channel, by profession, by sector of activity, by region, variation over time
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Acquisition and cost analysis, also analyzable according to several dimensions such as: time interval, distribution by distribution channel, by campaign, by profession, by region, variation over time.
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  <strong>24.4 AI Predictive HR Analytics Tool</strong>
                </p>
                <p>
                  A tool for viewing and forecasting the cost per application (CPA) for a given job posting, based on the job posting&apos;s key features. View and explore the various values using dashboards, graphs, and data mining features.
                </p>
                <p>
                  The data can be analyzed according to the following dimensions: profession, type of distribution channel, geographic region.
                </p>

                <p>
                  <strong>24.5 AI CV Parsing Tool (optional)</strong>
                </p>
                <p>
                  The Xtramile Parsing system is capable of semantically analyzing free text or scanned CVs, or even complete application files. The documents to be analyzed are made available (uploaded) in DOC, DOCX (MS Word), PDF (Portable Document Format), ODT (OpenOffice), TXT (Plain Text), RTF (Rich Text), PNG or JPEG (Joint Photographic Experts Group) or TIFF (Tagged Image File), HTML format.
                </p>
                <p>
                  The extraction result is provided as a JSON dataset.
                </p>
                <p>
                  The key functions of Parsing are:
                </p>
                <ul className={styles.listEL}>
                  <li>
                    <p>
                      <span>
                        Extracting information from CVs with different levels of granularity
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Extracting Photos into a Separate Image File
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Categorization of the field of occupation: classification of titles and professions of the positions occupied
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Type of languages supported: French and English
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Standardization of different parsed elements in a CV (dates, geographical locations, levels of education, skills, etc.) using dedicated repositories
                      </span>
                    </p>
                  </li>
                  <li>
                    <p>
                      <span>
                        Location of elements arranged in the CV
                      </span>
                    </p>
                  </li>
                </ul>

                <p>
                  Note: As part of CVS Parsing, Xtramile does not store any data.
                </p>

                <p>
                  <strong>24.6 AI Scoring Tool (optional)</strong>
                </p>
                <p>
                  Estimation of the quality score of relevant candidates based on given job offers and according to criteria of detailed understanding of the elements highlighted in job offer documents and candidate profiles.
                </p>

                <p>
                  <strong>24.7 X-Landing Page Tool (optional)</strong>
                </p>
                <p>
                  Providing a careers page to showcase your offers online and attract applications. This option is useful for clients who do not have a careers website.
                </p>

                <p>

                </p>
              </div>

              <div>
                <p className={styles.titleBlock}>
                  <strong>25. Appendix 2 – Personal Data</strong>
                </p>

                <p>
                  <strong>25.1 Description of the data processing carried out by us on your behalf</strong>
                </p>

                <table width={"100%"} cellPadding={6} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={204} />
                    <col width={374} />
                  </colgroup>
                  <tbody>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Purposes of processing personal data
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Provision of the Services described in the General Conditions
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Nature of processing operations
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p
                        className="western"

                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Collection, organization, structuring, conservation, use, communication by transmission and dissemination.
                      </p>
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        <br />
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Type of personal data processed
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p
                        className="western"

                        style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                      >
                        Depending on your choice:
                      </p>
                      <ul>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            Name
                          </p>
                        </li>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            First name
                          </p>
                        </li>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            E-mail
                          </p>
                        </li>
                        <li>
                          <p

                            style={{ orphans: 2, widows: 2, marginBottom: "0in" }}
                          >
                            Function
                          </p>
                        </li>
                        <li>
                          <p  style={{ orphans: 2, widows: 2 }}>
                            Phone number
                          </p>
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Categories of persons concerned
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Users
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={204}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Duration of treatment
                      </p>
                    </td>
                    <td
                      width={374}
                      style={{ border: "1px solid #000000", padding: "0.06in 0.28in" }}
                    >
                      <p className="western"  style={{ orphans: 2, widows: 2 }}>
                        Duration of the General Conditions
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <p>
                  <strong>25.2 List of Authorized Subsequent Sub-processors</strong>
                </p>

                <table width={"100%"} cellPadding={7} cellSpacing={0} style={{ marginBottom: "0.4in" }}>
                  <colgroup>
                    <col width={108} />
                    <col width={128} />
                    <col width={90} />
                    <col width={220} />
                  </colgroup>
                  <tbody>
                  <tr valign="top">
                    <td
                      width={108}
                      height={34}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Authorized subsequent sub-processors
                      </p>
                    </td>
                    <td
                      width={128}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Outsourced processing activities
                      </p>
                    </td>
                    <td
                      width={90}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Location of treatments
                      </p>
                    </td>
                    <td
                      width={220}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Appropriate safeguards in place in the event of data transfer outside the EU
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={108}
                      height={23}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Microsoft
                      </p>
                    </td>
                    <td
                      width={128}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Data hosting
                      </p>
                    </td>
                    <td
                      width={90}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Europe
                      </p>
                    </td>
                    <td
                      width={220}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        N/A
                      </p>
                    </td>
                  </tr>
                  <tr valign="top">
                    <td
                      width={108}
                      height={22}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Google
                      </p>
                    </td>
                    <td
                      width={128}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Data hosting
                      </p>
                    </td>
                    <td
                      width={90}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        Europe
                      </p>
                    </td>
                    <td
                      width={220}
                      style={{ border: "1px solid #000000", padding: "0in 0.28in" }}
                    >
                      <p className="western" style={{ orphans: 2, widows: 2 }}>
                        N/A
                      </p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

TermsAndConditionsPage.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default TermsAndConditionsPage;
